module.exports = {
  "+1Wujb": "{num} elementos",
  "+4lD9e": "Nombre",
  "+L9lak": "Aplicar plantilla de alarma",
  "+bRanp": "Por favor complete el número máximo de notificaciones",
  "+d7aNN": "Lista de plantillas de alarmas",
  "/COTHZ": "El nombre del módulo de alarma no puede estar vacío",
  "/cqdKk": "Descargar",
  "/l9tS2": "No activado",
  "/sI6h+": "",
  "z9+Z7p": "Seleccionar etiquetas",
  "03eM6t": "200 artículos/página",
  "0JCY6+": "Desplegador",
  "0sn8j/": "Por favor escribe tu nombre",
  "1UXyeT": "Tiempo de activación",
  "1WymPU": "Seleccionar valor de activación de alarma",
  "2+X2n8": "Eliminar por lotes",
  "28oE7E": "Ningún dispositivo seleccionado",
  "29A4OA": "Miembro de la empresa",
  "2QzYmY": "Cancelar",
  "2rDc7R": "Las reglas de alarma no pueden estar vacías",
  "2t0Cct": "Fecha de Implementación",
  "32AbcK": "Seleccione empresa",
  "36+mbi": "Estado de procesamiento",
  "3HzQUc": "Exportar JSON",
  "3RVwfq": "Por favor completa los comentarios",
  "3aYG4L":
    "Elimina la plantilla de alarma aplicada actualmente al dispositivo y ya no monitorea ni envía alarmas",
  "3qVnoZ": "Número de dispositivos ({num})",
  "4/e9qs": "Por favor, escribe el nombre",
  "4VVrWd":
    "¿Está seguro de desactivar ({name}) la plantilla de alarma? Después de desactivarla, los nuevos dispositivos de alarma no podrán aplicar la plantilla.",
  "4vWL+W": "Importar dispositivo",
  "4wi+/p": "Plantilla",
  "5SSVAQ": "Nueva plantilla de alarma",
  "5grmob": "Por favor, introduzca su dirección de correo electrónico",
  "5p8cBO": "Gestión de cuentas",
  "60Ixlm": "Nombre de la plantilla de alarma",
  "6ABIlp": "Estado del activador",
  "6mjOF/": "Reinicio por lotes",
  "7G1c4h": "Lista de dispositivos",
  "8PESa6": "Desactivar",
  "919TK9": "Formatos soportados: xls, xlsx",
  "9Kfib+": "Error desconocido",
  "9UefLp": "etiqueta",
  i5Nyva: "No leído",
  P76mDe: "Gestión de archivos sincrónicos",
  "5EJNIu": "Búsqueda de equipos entre empresas",
  wDqNy1: "Ejemplo",
  pGioLb: "Secuencia del dispositivo SN",
  "wnPTP+": "Ingrese el SN del dispositivo",
  ich0wH: "SN del dispositivo",
  wpKIvP: "Leer",
  B57Wbu: "Ningún dispositivo seleccionado",
  BC74I9: "Mensaje de aviso",
  BQcLxf: "Mover hacia abajo",
  BYbqwY: "Arrastra el archivo aquí o haz clic para cargarlo",
  BhkglP: "Ver token",
  BwXapw:
    "Por favor controle el nombre de la categoría dentro de 500 caracteres",
  CLqPBU: "Editar",
  D3lDHK: "Agregar regla de alarma",
  D5HOUz: "Seleccionar estado",
  E2kRYi: "Habilitación por lotes",
  "EZ+vMa": "Anotación de plantilla",
  EwM8Kj: "¿Estás seguro de que quieres mudarte?",
  Ey9rBq: "¿Estás seguro de que quieres eliminarlo?",
  F2LJDJ: "¿Estás seguro de que deseas eliminar?",
  F56ZKt: "Seleccionar miembros",
  FEb7U2: "Confirmar",
  "FaJ/jI": "No se seleccionó ningún archivo para importar",
  FbCeo1: "Valor de activación",
  FbsCUK: "Teléfono móvil",
  FeJVkL: "Agregar destinatarios adicionales",
  "Fr1I/b": "etiqueta",
  "G+BH4o": "¿Está seguro de eliminar el dispositivo actual ({name})?",
  GKSW97: "Desactivar lote",
  GQ5EVQ: "Por favor marque al menos uno",
  GUMdjP: "Último estado de ejecución",
  Gk0Mt5:
    "¿Está seguro de restablecer ({name}) el dispositivo de alarma? Después del reinicio, las reglas de alarma continuarán siendo monitoreadas.",
  GujK99:
    "Si el contenido de la plantilla de alarma se actualiza más tarde, también se sincronizará con el dispositivo aplicado",
  HN1dNJ: "Todas las cuentas",
  IqkgWZ: "Palabra clave",
  "Iwt/8W": "Anotación",
  "J0D5h+": "Hora de inicio",
  J9jPRL: "Copia exitosa",
  JJl2M9: "Exportar",
  JeJAmT: "Cambiar nombre",
  Jh62y5: "Todos los dispositivos",
  Jp7u8z: "",
  LWSLHa: "Recordatorio cálido",
  Ls1X2Z: "Procesado",
  "LuP+H0": "Descripción",
  LwhdsE: "Alternar selecciones múltiples",
  MnTdIi: "Número de activadores",
  MvGPdx:
    "¿Está seguro de habilitar ({name}) la plantilla de alarma? Después de habilitarla, los nuevos dispositivos de alarma pueden aplicar la plantilla.",
  N4np50: "Número máximo de notificaciones",
  NTanl8: "Agregar plantilla de alarma",
  NW8FV4: "Estado del comando del dispositivo",
  OsMncl: "No encendido",
  "P/eul9": "No",
  P6YSaZ: "Historial de alarmas",
  PgNsL5: "Implementando",
  "Py/5UG":
    "El nodo que se está operando ya no existe, por favor opere nuevamente",
  "Q2/NzC": "Se han seleccionado {num} dispositivos",
  QHhMxE: "Selecciona un personaje",
  QV3pnn: "Estado",
  "QavrS/": "Nombre de la regla",
  QwHI8Q: "Resultados de la consulta:",
  R2D5Dv: "Hora de creación",
  R3TTCW: "Editar plantilla de alarma",
  S57QRB: "Filtrar por",
  SGDlQ6: "{total} elementos en total",
  T3CtvK: "El nombre de la categoría no puede estar vacío",
  TDuPUp: "Activado",
  TqDOFU: "¡Por favor no envíe códigos de verificación con frecuencia!",
  U2DqqT: "Buscar empresa",
  UBbWUL: "Ninguna plantilla seleccionada",
  UFjZVV: "Estado de implementación",
  UUtqvk: "Sin procesar",
  UcumBq: "Notificación de alarma",
  UtE0dS: "Operación",
  "Uu/nFu":
    "Eliminar todas las plantillas de alarma aplicadas a este dispositivo",
  V0RiZp: "Operación exitosa",
  VR6zMp: "¿Estás seguro de que deseas desactivarlo?",
  VRizgn: "Por favor ingresa tu número de teléfono móvil",
  ViVQNi: "rol",
  WeKYMe: "Hora del último pedido",
  Wp6QLH:
    "¿Confirma que se restableció ({name}) la regla de alarma? Después de restablecerse, la regla de alarma continuará siendo monitoreada.",
  "WwRq+y": "Por favor agregue un objeto de notificación de alarma",
  "X/cNgA": "Eliminar recordatorio",
  XFEq9J: "Estado de la plantilla",
  XG2wHz: "Implementación exitosa",
  XMBOec: "Eliminar etiqueta",
  XeiAal: "Eliminar",
  XgmTAk: "Número de serie del dispositivo",
  YBAsWB: "Comando de grupo",
  YpXN8m: "Última hora de disparo",
  ZETl7o: "Plantilla de alarma",
  ZMUuo8: "¿Estás seguro de que quieres habilitarlo?",
  ZPSpaL: "Nombre del módulo de alarma",
  ZUPzqr: "Encender",
  "Zvt+2g": "Almacén",
  aBleoN: "Seleccionar plantilla de alarma",
  "aN+DgN": "Tiempo de activación",
  aiBGBs: "Eliminar con éxito",
  "arp+TQ": "50 elementos/página",
  "bE+h3K": "Estado del dispositivo",
  bOKDVF: "Alternar selección de radio",
  bqbDVw: "Consulta",
  cDZ00w: "Ver",
  drCsUI: "Empresa",
  e8OyHO: "20 artículos/página",
  f7Dpbl:
    "Descarga la plantilla y mejora el contenido según las indicaciones de la plantilla",
  fz2pkM: "Este nodo ha sido eliminado",
  gU4eZD: "Gestión de alarmas",
  ggvI6Z: "Seleccionar todo",
  gomg5W: "Desactivar recordatorio",
  gzHM5l: "Fecha de lanzamiento de la alarma",
  "hDx3/S": "Correo electrónico",
  hMboy7: "Detalles del estado del comando",
  iKomBu: "Aún no hay clasificación",
  ieTzi7: "Detalles de la plantilla de alarma",
  ifGp4v: "2FA",
  iyOrrD: "100 artículos/página",
  j6IHvr: "Ver detalles",
  jT6zKT: "Número de dispositivos",
  jdbKm7: "Objeto de notificación de alarma",
  jddlWH: "Error en la implementación",
  kCh5Jz: "pista",
  kG2Etz: "En línea",
  khyRcw: "Por favor seleccione el archivo Excel",
  kwOS33: "Habilitar recordatorio",
  l1fZNE: "No se pueden desmarcar todas las casillas",
  loTFGc: "Sin nombre",
  m0Qdyj: "Verificación fallida",
  ma6S6y: "Pantalla personalizada",
  "mpeFt+": "Reglas de alarma",
  nH1F3p: "¿Está seguro de eliminar la regla de alarma actual de ({name})?",
  nJCPaY:
    "El usuario no tiene una dirección de correo electrónico vinculada y no puede ser verificada",
  nUSeQB: "Ninguna cuenta seleccionada",
  nw8orn: "Número de personas notificadas",
  pBPyFt: "Versión Nubis",
  "pV2t/S": "Información básica",
  pcU9bM: "Agregar miembro",
  q6qKtH: "Condición de consulta:",
  qUKj7E: "Copiar",
  "r0/TUu": "OK",
  "r2dEd/": "Reiniciar",
  s9U9qn: "Establecer alarma",
  sOIerB: "No activado",
  sZSyGZ: "Habilitar",
  srEpKw: "Subiendo",
  srpWCM: "Marque los campos que deben mostrarse y arrástrelos para ordenarlos",
  t2iHNJ: "Actualizar",
  "tCh+iz": "Tiempo de activación de la alarma",
  tLW3W3: "Número de teléfono móvil",
  tokMPz: "Objeto de excepción",
  "uoZwj+": "Creador",
  v04auv: "Hora de finalización",
  w8L9Kj: "Configurar reglas de alarma",
  wOHHSJ: "Subir",
  wQAiLI: "Restablecer recordatorio",
  xISm1t: "activar",
  xUjLTE: "Buscar",
  y9NWzQ: "Lista de dispositivos de alarma",
  yGWx2z: "Error de parámetro",
  yOMNOj: "Sí",
  yReEcE: "Seleccionar etiqueta",
  yXsHgv: "10 artículos/página",
  yb3AuG: "fuera de línea",
  ybGQQ3: "Sin resultados relevantes",
  "yiO/gL": "Lista de plantillas",
  yxPDHk: "Estado de liberación",
  zH7h1q: "Historial",
  "96Mzoq": "Completado",
  ByhhM1: "Condición",
  PcCooF: "Valor de activación de alarma",
  RUMaeu: "Por favor complete las reglas de alarma completamente",
  h7w4pz: "Aún no hay datos",
  nMMNa6: "Te notificaremos por correo electrónico, SMS o sistema.",
  "nOE0/j": "Búsqueda de empresas y miembros",
  q6WPYA:
    "El dispositivo seleccionado contiene {num} versiones gratuitas de Nubis y no será posible enviar comandos en grupo.",
  "+CP3nr": "Seleccione una tarea",
  "+gbx50": "Condición de alarma",
  "+wet4N": "Error del código de verificación",
  "/BzHXM": "Selecciona el creador",
  "/SqqyP": "Ingrese el número de serie del dispositivo",
  "0YYUNG": "Se han seleccionado {num} etiquetas",
  "1M03Dq": "Plantilla de programación",
  "1SslIM": "Cerrar aplicación",
  "1gjtU2": "Última hora de ejecución",
  "1sj5Sj":
    "Eliminar todas las plantillas de programación aplicadas a este dispositivo",
  "2MYr1m": "Iniciar sesión",
  "2l+gFk":
    "¿Está seguro de habilitar ({name}) la plantilla de programación? Después de habilitarla, el dispositivo puede hacer referencia a la plantilla.",
  "2opnVU": "Durante la ejecución",
  "2r/XUW":
    "Eliminar todas las plantillas de programación aplicadas por esta etiqueta",
  "3xlnbE": "Tiempo de comando",
  "47GdDb": "Cerrar",
  "5ytYaf": "Nueva plantilla de programación",
  "65DvZ1": "Límite superior de entrada: 4",
  "6x6nu5": "Tiempo de ejecución real",
  "8zN+hZ": "Ejecutar aplicación",
  "9UZxwP": "Por favor ingresa el código de verificación",
  "9kkcTB": "Eliminar plantilla de programación",
  "9ljNkr": "Reenviar",
  "A/eXwT": "Eliminar todas las plantillas de alarma aplicadas a esta etiqueta",
  AyWMlZ: "Agregar tarea programada",
  BiPxfI: "Agregar plantilla de horario",
  C6cGK1: "El nombre de la plantilla de programación no puede estar vacío",
  EGvInA: "Lista de Alarmas de Equipos",
  Ft60hS: "Dispositivo Nubis",
  Gwj7xc: "Restaurar valor predeterminado",
  H15ECl: "Aplicación de entrada",
  "J3BW/8":
    "Por favor ingrese el código de verificación que recibió por correo electrónico",
  KW8qOm: "Seleccionar plantilla",
  LADN1a: "Estado de ejecución de la programación",
  Lfia0v: "Establecer horario",
  NDmD8V: "¿Está seguro de eliminar la plantilla de programación ({name})?",
  OVecAI: "Éxito",
  OwtOn5: "Estado total",
  PTc6Gt: "Habilitar programación",
  PaMvre: "Lista de reglas de alarma",
  PnYplH: "Equipo",
  RNaGVr: "Lista de errores de tareas",
  RWBRyt: "Mapa de distribución de equipos está en construcción",
  "RuFFf/":
    "¿Está seguro de desactivar ({name}) la plantilla de programación? Después de desactivarla, el dispositivo no puede hacer referencia a la plantilla.",
  SPyEF8: "Seleccionar modo",
  SwMBFl: "Aplicar plantilla de cronograma",
  TDSTTj: "Seleccionar plantilla de programación",
  UMU42c: "Seleccionar dispositivo",
  Unvxiq: "Cambiar cuenta",
  WxPZOH: "Ejecutar {num} veces",
  WypzMq: "Tareas programadas",
  X2m4ec: "Desactivar plantilla de programación",
  "YIgP+p": "Lista de programación de dispositivos",
  LNGTru: "Lista de errores de programación de dispositivos",
  YwEzx2: "Verifique los campos que deben mostrarse",
  Z2B362: "Continuo",
  ZBDct6: "Error: {núm}",
  ZHAjhZ: "Límite superior de entrada: 30",
  Zr9Dss: "Error",
  azDNha: "Enviado exitosamente",
  b5l2vN: "Guardar",
  b6y8Ai: "¿Estás seguro de desactivar ({name}) la programación?",
  bYIKFB: "En progreso: {num}",
  "e/6XZC": "¿No recibiste el código de verificación?",
  eAgY2G: "Ampliar filiales",
  fl7J8Y: "Mensaje",
  "gH+Az7": "Desactivar programación",
  gi4oTZ: "Lista de plantillas de programación",
  gplM71: "Diario",
  "hAd+eG": "Calendario de programación de equipos",
  "hD7/Lu": "Pantalla",
  hYN7oM: "Ocultar",
  hfn1Ux: "Éxito/Total",
  hkJXyi: "Configurar tareas programadas",
  "hkR3E+": "Modo de visualización",
  hwlmeB: "Tipo de destino",
  iN7Lps: "Modo bucle",
  iscUWH: "Completo: {num}",
  "j/YGZ0": "mapa",
  j6Hm96: "Ejecución programada",
  jNxbTC: "El código de verificación no puede estar vacío",
  js3tZs: "Nombre de la plantilla de programación",
  k9dozc: "Tiempo de ejecución",
  kUagYW: "Historial de ejecución de programación",
  l7IiCY: "Estado de programación",
  "lzP/we": "Descarga ORA",
  m1h20o:
    "Si el contenido de la plantilla de programación posterior se actualiza, también se sincronizará con el dispositivo aplicado",
  "mC2//O": "Ver calendario de programación",
  mFIXSq: "Número de serie del dispositivo",
  mISQTh: "Detalles",
  nGubXb: "Detalles de la plantilla de programación",
  nqPJwo: "para etiquetas",
  oCogiy: "comando",
  oY0m24: "usuario",
  oirnwv: "Habilitar plantilla de programación",
  ojz0Ke: "Ver más >",
  oru5FY: "Editar plantilla de horario",
  "p+zOzc": "resultado",
  peNVzr: "Cada {num} semanas",
  pfGGi0:
    "Elimine la plantilla de programación actualmente aplicada al dispositivo y no la ejecute más",
  pielKO: "Dispositivo de arranque",
  pkYJKs: "Estado de ejecución",
  qhC4wy: "Dispositivo de búsqueda",
  rUHCoM: "Programación de equipos",
  sb1vdX: "En progreso",
  u3dVQz: "Semanal",
  "urr92/": "Seleccione el implementador",
  vovKL8: "La ruta de la aplicación no puede estar vacía",
  "wrU/Kc": "Cada {num} días",
  ygAHaf: "Hora de envío",
  zvaxmN: "Gestión de horarios",
  "2ffDGT":
    "¿Está seguro de cerrar la tarea programada? El dispositivo no ejecutará la plantilla de programación después del cierre.",
  "D//rZg":
    "¿Estás seguro de eliminar la aplicación de la plantilla de programación?",
  E1GPl7: "Propietario",
  EwTMGn: "¿Estás seguro de habilitar ({name}) la programación?",
  GpzsBd: "Abrir tareas programadas",
  IM8kXz: "¿Estás seguro de eliminar la aplicación de ({name})?",
  KXqGQe: "Activación por lotes",
  NGe0Cs: "Eliminar registros de ejecución de cronograma",
  SkK50H: "Por favor agregue una tarea programada",
  Trt6ju:
    "¿Está seguro de iniciar la tarea programada? Después de iniciar, el dispositivo necesita ejecutar la tarea programada.",
  UiVtQS: "Cerrar lote",
  "Z56D+X": "Cerrar tareas programadas",
  aKxrop: "Eliminar la aplicación de plantilla de cronograma",
  miANEg:
    "¿Está seguro de cerrar ({name}) la tarea programada? El dispositivo no ejecutará la tarea programada después del cierre.",
  ngLF8L:
    "¿Está seguro de eliminar el registro de ejecución del cronograma de ({name})?",
  nqPOJc:
    "¿Está seguro de abrir ({name}) la tarea programada? Después de abrirla, el dispositivo necesita ejecutar la tarea programada.",
  oV0gpL: "Fecha de lanzamiento programada",
  xtHJEE: "No hay registros seleccionados",
  yifWnc: "¿Está seguro de eliminar el registro de ejecución del cronograma?",
  "+/R6RX": "Estado de la tarea",
  "35v5wD": "¿Está seguro de restablecer el historial de alarmas?",
  "3QXG/d": "Versión ora",
  "5jpkHg": "Estado en línea",
  G4XFn6: "Modelo de hardware",
  Ko5CPO: "¿Estás seguro de restablecer el historial de alarmas?",
  ajVpLe: "¿Está seguro de que desea eliminar este historial de alarmas?",
  dEXfrL: "Intervalo de estado de salud del dispositivo",
  eCCa0L: "Tipo de tarea",
  fr4nkj: "¿Estás seguro de que deseas eliminar el historial de alarmas?",
  nzsNwZ: "Estado de salud del dispositivo",
  qDba8m: "Estado del dispositivo fuera de línea",
  rDRAr0: "Versión del sistema operativo",
  YeF1dY: "Zona horaria",
  BC52ne: "Ignorado",
  SbZhau: "La tarea de inicio necesita especificar un dispositivo de inicio",
  "lsLYU/": "El número máximo de notificaciones no puede exceder 10",
  "NM/lRq": "Cancelar carga",
  "3qF993":
    "No puedes transferir dispositivos que no estén en tu empresa actual.",
  "6+iYA0": "número de serie",
  yc6ZUL: "Ora Estado de la última actualización",
  UA7mv6: "Ora Última hora de actualización",
  "fOwU1/": "pertenece",
  jNiwk6: "¿Está seguro de eliminar el dispositivo de alarma ({name})?",
  "lLa/D3": "Aplicar tipo",
  "wk1c/l":
    "Según el período de tiempo de actualización en escala de grises del dispositivo (hora local)",
  "5+oaTO": "estado de la última actualización de la imagen",
  "6pDRb2": "Por favor ingrese una contraseña válida",
  ANeFu6: "Verificar contraseña",
  GnzEo7: "hora de la última actualización de la imagen",
  s7NSze:
    "Por favor ingresa la contraseña de tu cuenta antes de confirmar la operación",
  "9RNrDU": "Si es un dispositivo proxy",
  "+TzicH": "Comerciante",
  "/CxA3j": "Agregar subcomerciante",
  "4c3uw8": "Eliminar comerciante",
  "5Hy0Qx": "No se puede transferir al mismo comerciante",
  BBpRbn:
    "Eliminar todas las plantillas de alarma aplicadas por este comerciante",
  DADacD:
    "Eliminar todas las plantillas de programación aplicadas por este comerciante",
  G9WbnV: "Para comerciantes",
  S1QSWC: "Importar subcomerciante",
  TYAJpp: "Se han seleccionado {num} comerciantes",
  Ve9Ksw: "Transferir Comerciante",
  Wzv7kF: "Por favor seleccione un comerciante",
  h7Yvwt: "Comerciante cruzado",
  jAAXdQ: "Comerciante de equipos",
  "kr+7Iy": "Buscar comerciantes",
  tFr3tb:
    "¿Está seguro de eliminar la plantilla de alarma ({name})? Después de la eliminación, la aplicación de esta plantilla por parte del dispositivo, el comerciante y la etiqueta se cancelará simultáneamente.",
  uuRzdk: "Atribuido al comerciante",
  vD5wnY:
    "Marcar el comerciante al que pertenece significa que tienes el permiso del comerciante",
  zyMKgy: "Seleccionar comerciante",
  RndUeh: "Tiempo estimado de ejecución",
  gcHeN9:
    "Por favor, complete el nombre de la aplicación del sistema operativo. Por ejemplo: Windows:chrome o Android:com.android.chrome",
  EM8lAi:
    "Según el período de tiempo actualizable del dispositivo (hora local)",
  "4Regzm": "Lista de comerciantes",
  "i6kDf/":
    "El dispositivo seleccionado contiene {num} versiones gratuitas de Nubis y los comandos del dispositivo no serán posibles.",
  o8tJYm: "Comando del dispositivo",
  "+74JfZ": "Ejemplo: Dispositivo_000001_Gaoqiao Merchant_Android",
  "+CLSks":
    "2. El tipo de sistema de dispositivo al que se aplica esta regla de nomenclatura",
  "+GQdfc": "Actualizar Token",
  "+m8vFq": "Detalles de la regla de nomenclatura",
  "0KH9Qi": "Tipo de sistema del dispositivo",
  "0Z908D": "Sólo puedes seleccionar una versión de la misma aplicación",
  "0bBO2n": "versión",
  "0iTEVO": "Ver token",
  "12LEcf": "¿Estás seguro de desactivar ({name}) esta regla de nomenclatura?",
  "1PtjRr": "Nombre del dispositivo",
  "2/LdaO": "Almacenar información de configuración",
  "2V19bd": "Detalles del archivo de configuración",
  "2jlHQB": "2. Reglas de nomenclatura predeterminadas de la empresa",
  "3ZtPM3":
    "Si la tienda no establece reglas de nomenclatura, las reglas de nomenclatura de la empresa se aplicarán al agregar nuevos dispositivos. Si no desea aplicar, puede desactivar las siguientes reglas",
  "3qgucc": "Establecer zona horaria manualmente",
  "5FboZ/": "Tipo",
  "5ZgUEM": "Editar plantilla de configuración",
  "5d3yZi": "Tiempo efectivo",
  "5noX9X": "Nombre del archivo de configuración",
  "6Ty5/G": "Publicado exitosamente",
  "7NmXNy": "Información del programa actual",
  "7PkBL6": "Habilitar actualizaciones silenciosas",
  "7ip592": "1. Nombre de la regla de nomenclatura",
  "88CuCZ":
    "3. Cree un método de nomenclatura para los dispositivos registrados en esta tienda (rellene automáticamente los nombres de los dispositivos)",
  "8WYGi+": "¿Estás seguro de que quieres copiar?",
  "8huAxo": "Agregar nueva regla",
  "8pB1C7": "Agregar aplicación",
  "8u3CYe": "Nombre de la regla de nomenclatura",
  "8zQ4So": "ID del paquete:",
  "96c3gX": "Formato",
  "9iKk2b": "Número inicial",
  AFZDo7: "Historial de instalación",
  B0WqD0: "1. Período de tiempo de actualización del dispositivo (hora local)",
  BqUpjt: "Por favor complete el nombre del paquete, como com.android.chrome",
  "CM76+/":
    "¿Está seguro de habilitar ({name}) esta plantilla? Después de habilitarla, el dispositivo puede hacer referencia a esta plantilla",
  CPTAAj: "Número natural creciente",
  CqlH6G: "Aplicar lista de tiendas",
  "D/Yid+": "Si habilitar",
  D2KnIQ: "Tienda asociada exitosamente",
  DpnauN: "hora",
  Fi4xFb: "Cargó la aplicación de Android exitosamente",
  G9APSK: "Editar reglas de nomenclatura",
  GRfLaO: "Nombre de la Aplicación",
  HDYjnT:
    "La versión de la aplicación seleccionada actualmente es inferior a la aplicación existente, lo que puede provocar que falle la instalación de la aplicación. Confirme si la aplicación está seleccionada correctamente. Si necesita instalar una aplicación con una versión inferior, puede verificar para eliminar el programa original y luego instalarlo.",
  HOHQFs: "El nombre de la regla de nomenclatura no puede estar vacío",
  "HdxQ2/":
    "Archivos de configuración relacionados con la tienda y reglas de nomenclatura",
  "I/k8FH": "Liberación",
  IyhhzI: "Crear archivo de configuración",
  Kj5TRg: "Número de dispositivos a instalar",
  "L4w/Vo": "Última versión",
  MI3yI1: "Subiendo {percentCompleted}%",
  MRe8Q9: "Número de versión:",
  NrEurQ: "Subir Mbps",
  Nrx60r: "Descargar Mbps",
  OCp4OD: "Ver archivo de configuración",
  PDFXBi: "Publicar ahora",
  PkLYZS: "Reglas de nomenclatura de dispositivos",
  PlNIQ9: "Configuración del sistema",
  "Q+0CDu": "Agregar regla de nomenclatura",
  Q5vbU5: "Los ID de los paquetes son inconsistentes",
  QpOtgZ: "Nombre de la tienda",
  R9TpN6: "Tiempo estimado de instalación",
  RY4VVr: "Cargador",
  RyXQqJ: "Tiempo de carga",
  UfxykZ: "razón",
  Unr58u: "Hora de actualización",
  Uzdb6l: "Tipo de dispositivo:",
  Vd3wZV: "En general",
  VqEr9u: "Aplicar el número de tiendas",
  WdyIyo: "Tiempo de operación",
  WfS4rv: "Operador:",
  "XLdI1+": "Intensidad de Wi-Fi",
  XnimdQ: "Windows",
  Ym4SPE:
    "Seleccione tiempo de liberación (tiempo de ejecución del dispositivo)",
  ZWN1C0: "¿Está seguro de habilitar ({name}) esta regla de nomenclatura?",
  ZdO12B: "Aplicar tienda",
  ZtZ7Yw: "Nombre del programa",
  aHlr3k: "Eliminar",
  akvGrq: "Reglas de configuración",
  aqQg0p: "área",
  bMdSkq: "Registro de prueba de velocidad de red",
  batMBC: "¿Estás seguro de que deseas eliminar la plantilla ({name})?",
  bsjenW: "Habilitar reglas de nomenclatura",
  cX08hK: "No hay datos seleccionados",
  cawvIS: "Última hora de actualización",
  cijnrq: "Dispositivo instalado",
  d8xSfX: "código de versión",
  dGBGbt: "Todos",
  dRYBRc: "Número de versión: {versión}",
  "devicesList@1": "Seleccionar todos los dispositivos",
  "devicesList@2": "Seleccionar todos los dispositivos",
  eUNh5K: "Dispositivo a instalar",
  "ecTX+c": "El nombre del programa es obligatorio",
  eeCxuz: "Tipo de SO",
  epaa3H: "Agregar reglas de nomenclatura",
  evJP5c: "Reglas de nomenclatura",
  fX0dsH: "Versión:",
  "fje/m/": "Nombre de plantilla:",
  fq3WGG: "Gestión de archivos de configuración",
  gQ7kPU: "Androide",
  gnNjS5: "Nombre del dispositivo personal",
  gyHdsW: "Plantilla de configuración",
  "gyh+d1": "Red de cable",
  hDmGQl: "Si se debe verificar el código de versión",
  hqGPDw: "Habilitar formato de 24 horas",
  hxy4wV: "Análisis",
  i5JzAA: "Estado:",
  i5MLJc: "Hora de la última actualización: {lastUpdate}",
  ie9Iom: "Ver plantilla de configuración",
  ifAmoA: "Plantilla de archivo de configuración",
  imhWD8: "Cargar configuración",
  iroVTo: "Configuración de la empresa",
  j2kqd8: "Eliminar reglas de nomenclatura",
  j3QWSE:
    "El número inicial para el incremento de números naturales sólo puede ser un entero positivo",
  jKzbw6: "Cambiar configuración",
  "jN5tO+": "Código de versión: {versionCode}",
  "jhfb/7": "Guardado exitosamente",
  k7dy8j: "Archivo de configuración asociado",
  kH9MHe: "Desactivar reglas de nomenclatura",
  kkLQie: "tienda asociada",
  "ksb/lB": "Si se debe eliminar el programa original",
  l0mW6t: "Última hora de actualización",
  mRHwkp:
    "¿Está seguro de deshabilitar ({name}) la plantilla? Después de deshabilitarla, el dispositivo no puede hacer referencia a la plantilla",
  "mYa6W/": "Texto personalizado",
  "mml+gT": "Seleccionar aplicación",
  mn0ceu: "Hay reglas de configuración duplicadas, por favor ajústelas",
  n1yIyi: "Tiempo de instalación",
  nDwIwd: "Publicado",
  nLERtc: "Actualizar aplicación Android",
  o9bMHL: "tamaño",
  oC6GBl: "aplicación de Android",
  "oFt+cN": "Prueba de velocidad de red",
  ovdKZi: "No se puede instalar el número de dispositivo",
  "p/3Nn5": "Red móvil",
  qS0aFJ: "Gestión de Aplicaciones",
  qUiH5y: "Las reglas de configuración no pueden estar vacías",
  qjtl3b: "Habilitar actualizaciones del sistema",
  "qqwM/t": "Archivo de configuración",
  rdEPl7: "No se puede instalar el dispositivo",
  rsAvN6: "Nombre del programa:",
  rw3uGa: "Nueva plantilla de configuración",
  "s+aIlP": "Buscar nombre de tienda",
  saeFbf: "Archivo",
  t8R6VW: "ID del paquete: {paquete}",
  tWcCoB: "Fecha de la prueba de velocidad",
  twpxdo: "Subir aplicación de Android",
  "u/NB+Y": "ID del paquete",
  vDCwZ9: "Subir archivo",
  vLW90z: "¿Está seguro de eliminar la regla de nomenclatura ({name})?",
  vr5TVT: "Por favor ingrese",
  wiSRo9: "Número de dispositivos instalados",
  "xE1H+X": "Configuración",
  xdjVt1: "Nombre de la plantilla no completado",
  xlNcvg: "Última actualización:",
  xrQzKh: "Por favor, complete el nombre de la aplicación, como Chrome",
  xwYDb8: "Código de versión:",
  ydktLD: "delimitador",
  zeMk2K: "Borrador",
  zok1hp: "Ranura C",
  zrIs7T: "Última hora de actualización",
  "a++4i0": "La hora de publicación debe ser después de 24 horas",
  "3JwoQQ": "La carga falló y la aplicación no puede analizarla.",
  "9Fvzl9": "Liberación por lotes",
  OiP4rW:
    "Actualmente hay un archivo de configuración asociado con una tienda, verifíquelo.",
  b95U3r: "Lista de archivos de configuración",
  nJetAr: "Formato no compatible.",
  lPA1qT: "Esta configuración es sólo para dispositivos específicos",
  oXfYag: "El código de versión ya existe, cárguelo nuevamente",
  "k+a7BC": "Realizar tiempo de actualización silenciosa",
  "+cCXuw": "Seleccionar imagen del archivo",
  "0cZQXI": "Agregar por ID de paquete",
  "0xm1Zu": "Bloquear combinación de teclas",
  "33bmiC": "El directorio principal no existe",
  "4UcMA+": "Agregar Wi-Fi",
  "4ia8sI": "Control de Funciones",
  "4o167y": "La longitud del texto personalizado no puede exceder los 30",
  "66awCH": "Actualizar",
  "C+cw77": "Configuración del fondo de pantalla",
  E6G3sr: "Modo quiosco",
  "FQK+2G": "Sincronización de archivos",
  FWlWJR: "Ver información de la tienda",
  HI1PTY: "Ingrese la ruta de la carpeta",
  HNavdr: "Nombre de la empresa",
  JPIKnb: "Pantalla de inicio",
  MufYuw: "Pantalla de bloqueo",
  NPjnPZ: "Brillo",
  "Pdx/YD": "Contraseña",
  Pg5mqb: "Modo paisaje",
  QSjBm5: "El archivo no existe",
  UH1kCc: "Agregar",
  UduVZX: "Seleccionar archivo",
  Usn1oq: "Modo retrato",
  "Ymq1/H": "Nombre de la carpeta del dispositivo",
  YzG9Iw: "Lista negra",
  ZK1d6f: "SSID",
  bGGvOS: "Seleccionar imagen",
  c8uKl6: "Wi-Fi",
  dZlNkV: "Agregar configuración",
  dmEBpU: "Configuración de sincronización de archivos",
  foT1aq: "Progreso de carga actual:",
  g5Pknn: "El tamaño del archivo excede el límite",
  gltp3e: "Desactivar las notificaciones de Windows",
  gweUAO: "Bloquear interfaz USB",
  nxeBGd: "Ejemplo:",
  o8HwKf: "Nombre de archivo",
  rULuF3: "Si sólo se permiten las siguientes conexiones de red",
  tIm58E: "Detener",
  tR69qg: "Idioma de visualización de Windows",
  tnYpSo: "Solicitud de detección enviada exitosamente",
  xNeD5U: "Cancelado",
  xiwfUp: "Volumen",
  znna6r: "Almacenar información",
  "/k2Fs5": "Reglas de nomenclatura de configuración",
  e2ys3T: "Almacenar información de configuración",
  yy7EDI: "Subir",
  "+UT6Us": "Zimbabue",
  "+cSl6d": "Países Bajos",
  "+vx0UI": "Islas Salomón",
  "+vz4Gy": "Sierra Leona",
  "/1g/gd": "Kiribati",
  "/EzG+0": "Montserrat",
  "/ZaEbq": "Haití",
  "07BMT/": "Argelia",
  "0E6+/f": "Guam",
  "14axoc": "Islas Malvinas",
  "1BFTBO": "Cuba",
  "1GLoiG": "Georgia",
  "1Z3cpQ": "Costa de Marfil",
  "1qc1Bb": "Letonia",
  "217kis": "Ruanda",
  "2c/STs": "Moldavia",
  "3B2kCX": "Islas Feroe",
  "3Nlsp9": "Eslovaquia",
  "3a17nf": "Islas Cook",
  "41lx/9": "Afganistán",
  "4KMP9f": "Congo",
  "4obEtL": "Togo",
  "5w+tOJ": "Albania",
  "62Z8c1": "Palaos",
  "6JR/Y7": "Irlanda",
  "6LZPqX": "Samoa",
  "6Mnz8p": "Mauritania",
  "6NPwCy": "Siria",
  "6f8kym": "Irak",
  "6qdPnx": "Túnez",
  "7KZ6vz": "Venezuela",
  "7hGupC": "Lituania",
  "7hNQVL": "Filipinas",
  "7p85Tc": "Curazao",
  "8m5tda": "Egipto",
  "8y7qAE": "República Centroafricana",
  "98qFTO": "Jersey",
  "99fbLn": "Uruguay",
  "9T1JPo": "Malta",
  AD5RPE: "Guinea Ecuatorial",
  AKnToQ: "Chad",
  "AO/9GT": "Finlandia",
  AYs4yh: "Madagascar",
  Ai6HyC: "Uganda",
  AksTq6: "Antigua y Barbuda",
  ArbweL: "Jordania",
  AzRGCX: "Alemania",
  "B/oRh5": "Micronesia",
  BcJbbP: "Catar",
  Bm5GdP: "Taiwán",
  MRbe2A: "Taiwán",
  BwMY6I: "Sahara Occidental",
  BxT2qw: "Tokelau",
  C0YR5J: "Turkmenistán",
  C2pikc: "Sudán del Sur",
  C7RUR5: "Nauru",
  CKu8W1: "Niue",
  CYSGlA: "Estonia",
  "D/Hl19": "Martinica",
  DPthJ5: "Luxemburgo",
  Dxf50E: "Comoras",
  EMaGPN: "Somalia",
  "Eihfz+": "Pakistán",
  Eul4yJ: "Italia",
  F0BTvX: "Reunión",
  FsQ2Ph: "Islas Marianas del Norte",
  FzXhJn: "Ciudad del Vaticano",
  GRDGdf: "Nueva Caledonia",
  "HF/NiY": "Armenia",
  HN9EHr: "Corea del Sur",
  HTqMY5: "Rumanía",
  HZs8KL: "Burkina Faso",
  I2RkrK: "Camboya",
  I7Erl3: "Marruecos",
  IGBRed: "Azerbaiyán",
  IPfyBg: "Irán",
  IbG9YJ: "Isla Norfolk",
  "IrME/4": "Macao",
  XeQT0P: "Macao",
  J1oSvz: "Islas Vírgenes de los Estados Unidos",
  JIPBj1: "Jamaica",
  JIWrkV: "Canadá",
  JJhl02: "República Democrática del Congo",
  JOJTuh: "Costa Rica",
  JddSbX: "Dominica",
  L7PjzJ: "Isla de Navidad",
  LShUE0: "Bután",
  "Le+IiI": "Macedonia del Norte",
  LeMbDw: "Zambia",
  LfkgD6: "Australia",
  Lszars: "Estados Unidos",
  M16xFB: "Brunéi",
  MMzrYK: "Liechtenstein",
  MTVChl: "Tonga",
  MXueJK: "Andorra",
  MYneOz: "Yibuti",
  MZwu6r: "Islas Heard y McDonald",
  MbV1M9: "Malasia",
  MkBrsn: "Paraguay",
  MwNlM3: "Burundi",
  MyB1Vf: "Arabia Saudita",
  NcwUGt: "Israel",
  OZFYbQ: "Vanuatu",
  OZyB9b: "Bosnia y Herzegovina",
  Oc4oig: "Bolivia",
  OhEAqA: "Grecia",
  Oql6Jb: "Portugal",
  PB00mS: "Wallis y Futuna",
  PBGuz3: "Polonia",
  PIBLYF: "Hong Kong",
  "1ObLsW": "Hong Kong",
  PIHPBR: "San Martín (parte francesa)",
  PjOc8o: "Bielorrusia",
  "Q+FGAs": "Islandia",
  "Q5QY0+": "Islas Caimán",
  Q5U8nY: "Samoa Americana",
  QA9U89: "Territorio Británico del Océano Índico",
  QRUdeg: "México",
  QxRaqi: "Dinamarca",
  RfQSLo: "Corea del Norte",
  RlB4rB: "Georgia del Sur y las Islas Sandwich del Sur",
  RsWzOr: "Hungría",
  RzKiE0: "Puerto Rico",
  SEJjjI: "Antártida",
  SLmrMX: "Bulgaria",
  T6qzNm: "Laos",
  Tb6AtC: "Emiratos Árabes Unidos",
  To4yI6: "Gambia",
  TqXGpl: "Belice",
  UQHsPm: "Cabo Verde",
  UZmEHG: "Mongolia",
  Ulf4Sq: "India",
  VCRq6v: "Islas Pitcairn",
  VIFtwp: "Camerún",
  VTEHKS: "Guinea-Bisáu",
  VWg1hF: "Svalbard y Jan Mayen",
  VhGXkw: "Islas Åland",
  W2fcGi: "Surinam",
  W9gKgU: "Seychelles",
  WAl9tj: "Timor Oriental",
  "WH+mo5": "Uzbekistán",
  WJAfY4: "Tuvalu",
  WobBPP: "Liberia",
  XfoqmV: "El Salvador",
  XoOuKT: "Kazajistán",
  YINkHp: "Serbia",
  YMjT8q: "Singapur",
  "Z+fptr": "Colombia",
  ZHe4St: "Indonesia",
  ZRhaI4: "Barbados",
  ZgLO7j: "Líbano",
  a9nZYf: "Isla Bouvet",
  aNVBIV: "Francia",
  afgUkt: "Trinidad y Tobago",
  ahaefV: "China",
  b8Yur0: "Benín",
  bCl9eg: "Vietnam",
  bKHwtk: "Bangladés",
  bQkGVT: "Federación Rusa",
  "cio5m/": "Nueva Zelanda",
  "d+SgS7": "Nicaragua",
  d97FOT: "Papúa Nueva Guinea",
  dUeWgE: "Fiyi",
  dXFo2O: "Noruega",
  dcfcTW: "San Pedro y Miquelón",
  dyBAW0: "Senegal",
  eNa9WG: "Santa Elena",
  eX9WT0: "San Marino",
  eiecNW: "Lesoto",
  eu7j6G: "Montenegro",
  f6i4Ch: "República Dominicana",
  fSGNZz: "Bélgica",
  fe4fox: "Sudán",
  fp4MWN: "Japón",
  g44w8D: "Reino Unido",
  gIZauu: "Guatemala",
  gb8v87: "Turquía",
  h70zPD: "España",
  hB6jsF: "Chipre",
  hBpMeF: "Islas Marshall",
  hC0etv: "Chile",
  hLeEYi: "San Vicente y las Granadinas",
  hrmyDn: "Tanzania",
  htLGF6: "Bonaire",
  htNRZG: "Mónaco",
  hy4yn7: "Kirguistán",
  iJsE6u: "Malí",
  iVyVIA: "Guernsey",
  iYdC7o: "Nepal",
  icfTwL: "Sri Lanka",
  icoYQF: "Territorios Australes y Antárticos Franceses",
  ipoOkJ: "Níger",
  j2GbDK: "Santo Tomé y Príncipe",
  "j83TV+": "Isla de Man",
  jHmcI7: "Guinea",
  jKdq05: "Aruba",
  "jZLo+u": "Yemen",
  kCwSgm: "Suecia",
  lAVHXj: "Gabón",
  lc0eVA: "San Bartolomé",
  ljBSDy: "Baréin",
  mIgnTu: "Bermudas",
  mdbt1h: "Granada",
  n1eYYR: "Croacia",
  n6sdJi: "Nigeria",
  nU0AoJ: "Mauricio",
  nbVGOe: "Guyana",
  ncprFv: "Palestina",
  nfMTZ9: "Libia",
  "oC/YmL": "Angola",
  oJA0AV: "Ucrania",
  ofe1Jv: "Eslovenia",
  ox0SUk: "Eritrea",
  pG9dnN: "Guayana Francesa",
  pGsPfz: "Tayikistán",
  "prG89+": "Sint Maarten",
  "qKL/I7": "Ecuador",
  qhRoDt: "República Checa",
  r0r576: "Austria",
  riK5Od: "Mayotte",
  "s/ZbGB": "Gibraltar",
  sVaevR: "Polinesia Francesa",
  sgg3ZA: "Kenia",
  srKhxN: "Bahamas",
  ssKHGM: "Groenlandia",
  swmjZg: "Tailandia",
  "tUisY+": "Ghana",
  u3ws3s: "Sudáfrica",
  u9cEKj: "San Cristóbal y Nieves",
  uPO36O: "Myanmar",
  uY8iM9: "Mozambique",
  ufZlit: "Panamá",
  ufyzs9: "Santa Lucía",
  v8IwQb: "Argentina",
  vPS1uD: "Perú",
  vTEjni: "Malaui",
  vcSBZu: "Brasil",
  vixhhG: "Maldivas",
  "wL/u2o": "Islas Turcas y Caicos",
  "wYCJ++": "Esuatini",
  "we/YPm": "Omán",
  xFrFSm: "Namibia",
  xV0lln: "Islas Vírgenes Británicas",
  xepQSL: "Islas Cocos",
  xk4ByO: "Guadalupe",
  xwICWz: "Suiza",
  yC4n0v: "Kuwait",
  yKWAek: "Anguila",
  yLlbwi: "Botsuana",
  zhs13i: "Honduras",
  zw39MM: "Etiopía",
  "+31PFz": "Asia/Urumqi",
  "+6yBji": "Asia/Bangkok",
  "+CgfU2": "Pacífico/Efate",
  "+POdLR": "Europa/Volgogrado",
  "+VqRkg": "América/Kentucky/Monticello",
  "/+Dhy+": "América/Sao_Paulo",
  "/D9zXZ": "Atlántico/Reikiavik",
  "/UGQnF": "América/Nome",
  "0DYv/B": "África/Nairobi",
  "0HnaGc": "Pacífico/Kwajalein",
  "0R8CQs": "Europa/Budapest",
  "0xV9JO": "América/Argentina/La_Rioja",
  "1H4FmE": "Europa/Uzhhorod",
  "1mv3LM": "Asia/Chita",
  "1pl9Su": "África/Trípoli",
  "1sEPCz": "Asia/Tokio",
  "1ua619": "Europa/Praga",
  "23aBJh": "América/Denver",
  "2DXZtH": "Europa/Copenhague",
  "2OWj6s": "Asia/Beirut",
  "2WXSh8": "Asia/Karachi",
  "2qYhi8": "Asia/Hong_Kong",
  "2s/Mlc": "Asia/Kamchatka",
  "2zQAXL": "Europa/Chisináu",
  "327IN3": "América/Yakutat",
  "339CIL": "América/Belice",
  "3Lz3cq": "Pacífico/Enderbury",
  "40b51E": "América/Miquelon",
  "4AZ4gQ": "América/Argentina/Salta",
  "4D94K+": "Antártida/Casey",
  "4NXksL": "Europa/Lisboa",
  "4XF+Io": "América/Tegucigalpa",
  "4l3qM7": "Pacífico/Noumea",
  "4neOsl": "América/Danmarkshavn",
  "4wb1r/": "Europa/Luxemburgo",
  "5M8Wkq": "América/Argentina/Jujuy",
  "5oeyFi": "América/Argentina/Rio_Gallegos",
  "5xwaJJ": "Pacífico/Funafuti",
  "6/dk2l": "Europa/Simferópol",
  "6Rz5js": "África/El_Aaiún",
  "6XgRmz": "Asia/Hovd",
  "6d5tvh": "América/Boa_Vista",
  "6wYqzG": "Pacífico/Wake",
  "71fHGN": "América/Guyana",
  "7Q7WxK": "América/Guatemala",
  "7WBtG1": "Pacífico/Majuro",
  "7euHXg": "Pacífico/Bougainville",
  "7jiQ+M": "Asia/Taipéi",
  "82GEmf": "Pacífico/Nauru",
  "8DjTJi": "Pacífico/Fakaofo",
  "9Fhwtp": "África/Monrovia",
  "9TfEAv": "Asia/Daca",
  "9UC6g0": "Asia/Macao",
  "9xN38t": "Asia/Riad",
  A1qgI0: "América/Campo_Grande",
  A8Tpo2: "África/El_Cairo",
  ADtcg9: "América/Indiana/Petersburg",
  AQnn4z: "Asia/Catar",
  AX2M6K: "África/Casablanca",
  ApEhaf: "Antártida/Vostok",
  "BsRS+L": "África/Lagos",
  "CIpc+3": "Asia/Rangún",
  CJgAlM: "América/Argentina/Buenos_Aires",
  CMi686: "Europa/Samara",
  CRI2Ve: "Pacífico/Chatham",
  CezJKN: "América/Santiago",
  "Cs/zIo": "Pacífico/Marquesas",
  CvKLCn: "Pacífico/Tongatapu",
  CwyqPj: "África/Accra",
  D1tmTQ: "América/North_Dakota/Center",
  D55vg4: "África/Túnez",
  DAlYN5: "Europa/Estambul",
  DCrzIX: "Europa/Andorra",
  DDqHds: "África/Jartum",
  DQsykN: "América/La_Habana",
  DVZRDC: "Europa/Oslo",
  DcYI27: "África/Maputo",
  "EGDZo+": "Asia/Srednekolymsk",
  EcRGq9: "Asia/Dubái",
  EgIxeE: "América/Jamaica",
  "EnTK+r": "América/Chicago",
  EqvKbF: "América/Cuiabá",
  F0y8e9: "América/Los_Ángeles",
  F465cE: "Europa/Helsinki",
  F6OWRn: "Pacífico/Port_Moresby",
  FDGDXD: "Europa/Kiev",
  FEnpn4: "Europa/Berlín",
  FeFqOa: "Asia/Choibalsan",
  "G0/1QH": "América/Paramaribo",
  "GHrEk+": "Asia/Ho_Chi_Minh",
  Gcuin4: "Asia/Ulan_Bator",
  "H+kwCw": "Asia/Brunéi",
  "H/TECz": "Asia/Seúl",
  H11GhT: "Asia/Jandyga",
  HD7dNh: "Asia/Qyzylorda",
  HDlqGj: "América/Argentina/Tucumán",
  HSmzBV: "América/Argentina/San_Luis",
  I2fe6r: "Asia/Hebrón",
  ID5HGa: "Pacífico/Guam",
  "IRsI+H": "Asia/Makassar",
  IVs8gT: "Océano Índico/Mauricio",
  "IYKKU/": "Asia/Ereván",
  IYSP57: "América/Santarém",
  JGg252: "Asia/Dili",
  "JJJ+wW": "Pacífico/Wallis",
  JTTFhT: "Pacífico/Kosrae",
  KBQ98i: "Europa/Sofía",
  L6RwvT: "América/Scoresbysund",
  LFkBwb: "Asia/Kuala_Lumpur",
  LGJGKo: "América/Indiana/Winamac",
  LepYst: "América/Argentina/San_Juan",
  LrC3cb: "África/Johannesburgo",
  M74J18: "Pacífico/Apia",
  "MS/dmQ": "Europa/Vilna",
  MYvQtB: "Pacífico/Ponapé",
  MhFcna: "Asia/Aktau",
  MpIqyW: "Asia/Novosibirsk",
  "N69J/J": "América/Caimán",
  N7RBEQ: "Europa/París",
  "NLL9E/": "Asia/Singapur",
  Nap8NB: "América/La_Paz",
  NhLpaB: "Asia/Gaza",
  NwiC8y: "Asia/Bakú",
  OPz5aV: "Europa/Varsovia",
  "OSP/DU": "América/Araguaína",
  "OoH/k4": "Europa/Malta",
  OqlGXK: "Atlántico/Feroe",
  OtFyGC: "Europa/Zaporizhia",
  P9EyMh: "Asia/Almatý",
  PRo9ZX: "América/Grand_Turk",
  Pbr43k: "Pacífico/Gambier",
  PdnZvE: "América/Indiana/Knox",
  Phhnuu: "Pacífico/Guadalcanal",
  "PlA+93": "América/Anchorage",
  "Q+QFi7": "América/Panamá",
  Q0Nwql: "América/Nassau",
  Q2hC7E: "Asia/Anadyr",
  RTFf0R: "Asia/Tashkent",
  RVtTvI: "América/Bogotá",
  RcUwWS: "Europa/Tirana",
  Rfu8ru: "América/Juneau",
  RzRPhx: "Asia/Teherán",
  SRDvbw: "Océano Índico/Navidad",
  SkSGFq: "América/Asunción",
  SqYr66: "Pacífico/Truk",
  T7X3nR: "América/Costa_Rica",
  TnMEvg: "Europa/Riga",
  TnQgWT: "Océano Índico/Cocos",
  UE61nU: "Asia/Yakarta",
  UEbt0M: "Europa/Atenas",
  UjOTtz: "Europa/Mónaco",
  VlcnXa: "Atlántico/Azores",
  WICb5K: "Asia/Magadán",
  "WJ+FQF": "Asia/Tiflis",
  WTSjw5: "Pacífico/Pago_Pago",
  WUi6ng: "Asia/Kuching",
  WX1P13: "Antártida/Davis",
  Wb2LCw: "Antártida/Rothera",
  Wg0kce: "América/Indiana/Vincennes",
  WhpVLY: "América/Guayaquil",
  Wq4Z0k: "América/Belém",
  XK8hFK: "América/Rio_Branco",
  XLgiC3: "Pacífico/Norfolk",
  XN4sjj: "Asia/Samarcanda",
  XuXXK5: "América/Recife",
  YOJC0Y: "América/Indiana/Marengo",
  Yux40Y: "Antártida/Palmer",
  "Z+d4VE": "Europa/Ámsterdam",
  ZOXOj5: "Antártida/Mawson",
  "aKg/xg": "Antártida/Troll",
  "aqHEW/": "África/Argel",
  aqZ1dw: "Pacífico/Galápagos",
  aylTTV: "América/Curazao",
  "b5+eh2": "Asia/Bagdad",
  b5GT3E: "África/Bisáu",
  bf8oMi: "Pacífico/Kiritimati",
  bkKBAQ: "Asia/Pontianak",
  c5lOtj: "Asia/Vladivostok",
  cCvy0S: "América/Caracas",
  ciyA6X: "Asia/Manila",
  cl18LV: "Asia/Ust-Nera",
  d6W7pe: "Europa/Moscú",
  dw9A9j: "América/Argentina/Mendoza",
  e77Cv2: "Asia/Yakutsk",
  e88zL2: "Asia/Nicosia",
  eDz3Tw: "América/Adak",
  eJqVsD: "Europa/Gibraltar",
  "eR7v+R": "América/North_Dakota/Beulah",
  ekhdTj: "Asia/Jayapura",
  "f6G4/S": "Pacífico/Auckland",
  f6r66H: "América/Menominee",
  fJpD6E: "África/Ndjamena",
  fqXfBN: "Europa/Roma",
  "fxAR+x": "Asia/Oral",
  g2HLMh: "Antártida/Syowa",
  gU3Odo: "América/Nueva_York",
  "gibo/e": "Europa/Viena",
  gln1VX: "América/El_Salvador",
  guiUEK: "Europa/Bucarest",
  gycX1L: "América/Noronha",
  h5YZ1i: "Europa/Bruselas",
  hI5EVU: "Océano Índico/Reunión",
  hKq7PN: "Europa/Kaliningrado",
  hL3apR: "América/Lima",
  hZiOxa: "América/Puerto_Rico",
  hdgzx5: "Pacífico/Pascua",
  hrq9xi: "Europa/Minsk",
  iBXv4d: "América/Metlakatla",
  inPmEU: "Europa/Tallin",
  jRwF7m: "América/Fénix",
  jaNloj: "América/Maceió",
  jtTALf: "Pacífico/Honolulu",
  k6R7DN: "América/Fortaleza",
  kLf0tS: "América/Detroit",
  lAz3SQ: "Asia/Biskek",
  lNijTx: "Atlántico/Stanley",
  m5vKwe: "Asia/Calcuta",
  mXs7zw: "América/Sitka",
  mnvAEu: "América/Indiana/Tell_City",
  n8UW9y: "Asia/Ekaterimburgo",
  nYFNxR: "Asia/Sajalín",
  o5Rywj: "América/Argentina/Catamarca",
  oYmVJJ: "Asia/Krasnoyarsk",
  ocqIaV: "Océano Índico/Chagos",
  ocqwXs: "Asia/Omsk",
  okHgMB: "Asia/Dushambé",
  pKp9LP: "América/Indiana/Vevay",
  pNrCwc: "América/Manaos",
  pQ5zcx: "América/Argentina/Ushuaia",
  pcGYLU: "América/Thule",
  pvDJax: "América/Barbados",
  "q5++81": "Europa/Londres",
  q7mJWt: "América/Boise",
  "qSxe/X": "Europa/Zúrich",
  rB9Ewl: "Asia/Aqtöbe",
  rIY0ZR: "Océano Índico/Maldivas",
  rZTr8Y: "América/Indiana/Indianápolis",
  rhN321: "América/Nuuk",
  rslOL6: "Pacífico/Tarawa",
  rwZktH: "América/Argentina/Córdoba",
  s2obSj: "Pacífico/Palaos",
  s3GZlv: "América/Puerto_España",
  slYOe6: "América/Cayena",
  szkWWk: "América/Bahía",
  t5CPbZ: "Europa/Dublín",
  tHE78L: "América/Santo_Domingo",
  tMDDnr: "América/Managua",
  tUaF1F: "Pacífico/Niue",
  tlkIG3: "Pacífico/Fiyi",
  "tw/bjJ": "Asia/Novokuznetsk",
  u0TM9W: "América/Puerto_Príncipe",
  uMXTTe: "Europa/Estocolmo",
  uNiOLq: "Asia/Jerusalén",
  "uOkO/r": "Asia/Irkutsk",
  "utbU0+": "Asia/Ashgabat",
  ux1XM2: "Atlántico/Bermudas",
  "v+arTX": "América/Eirunepé",
  vMATTy: "Asia/Damasco",
  "vWWiU+": "Asia/Pyongyang",
  vbHpIo: "África/Windhoek",
  vn9nKr: "América/Porto_Velho",
  vohVUs: "Asia/Kabul",
  vwtvCc: "Atlántico/Cabo_Verde",
  vy4zY8: "Asia/Colombo",
  w7kHCL: "Atlántico/Madeira",
  wDFHDz: "América/Martinica",
  "wbQai/": "Atlántico/Georgia_del_Sur",
  wrZg4b: "Asia/Thimphu",
  xAcBeP: "Pacífico/Tahití",
  xKA8d6: "Antártida/DumontDUrville",
  "xx+5iB": "América/Kentucky/Louisville",
  y79PlA: "Asia/Amán",
  yaBGO1: "Pacífico/Pitcairn",
  yeltlL: "Océano Índico/Mahé",
  ygabsP: "América/North_Dakota/New_Salem",
  z6KEn9: "Pacífico/Rarotonga",
  z98zna: "Océano Índico/Kerguelen",
  zWABd8: "Europa/Belgrado",
  zm3ZI2: "Asia/Shanghái",
  zwjmMl: "Asia/Katmandú",
  "e5x+i6": "Australia/Lord_Howe",
  gAtxKw: "Antártida/Macquarie",
  P5aTR8: "Australia/Hobart",
  "nFhe/c": "Australia/Currie",
  e6YJm8: "Australia/Melbourne",
  dmcxmV: "Australia/Sídney",
  jFnCUr: "Australia/Broken_Hill",
  i5MwAy: "Australia/Brisbane",
  WyjEwT: "Australia/Lindeman",
  JuasJd: "Australia/Adelaida",
  co8c88: "Australia/Darwin",
  qm4oIk: "Australia/Perth",
  "0LrMZs": "Australia/Eucla",
  "+E914Q": "Francés (Reunión)",
  "+FHEub": "Tamazight del Atlas Central (Árabe)",
  "/AAqs8": "Portugués (Guinea Ecuatorial)",
  "/BbMQN": "Cingalés",
  "/NVZFV": "Portugués (Angola)",
  "/V7bTl": "Fula (Latín, Gambia)",
  "/YFnxw": "Saho",
  "/stiNv": "Tailandés",
  "019rDM": "Portugués (Portugal)",
  "01GXUP": "Fula (Latín, Guinea)",
  "0BWpf+": "Japonés",
  "0CHkPh": "Frisón Occidental",
  "0D82eT": "Croata (Bosnia y Herzegovina)",
  "0fzUyn": "Portugués",
  "0mDCSY": "Español",
  "0rqbd/": "Maltés",
  "160k/R": "Ruso",
  "1BHQDP": "Bengalí (India)",
  "1F0Uz0": "Árabe (Irak)",
  "1J25kd": "Bosnio (Eslavo)",
  "1RqABh": "Lituano",
  "1dv927": "Malayo (Brunéi)",
  "29JxAe": "Inglés (Reino Unido)",
  "2LBIWM": "Inuktitut",
  "2OXQzm": "Danés",
  "2atqiI": "Oromo",
  "2hRVBA": "Serbio",
  "30RDW+": "Árabe (Catar)",
  "3PyL86": "Inglés (Filipinas)",
  "3Rvul8": "Tibetano (India)",
  "3ijo+p": "Neerlandés (Surinam)",
  "4+Zl7y": "Español (El Salvador)",
  "4Od9+t": "Serbio (Eslavo, Bosnia y Herzegovina)",
  "4U3ZpB": "Francés (Haití)",
  "4Xzh0/": "Portugués (Suiza)",
  "4eGD8c": "Fula (Latín, Sierra Leona)",
  "4fkP4F": "Español (Cuba)",
  "4lbmZs": "Español (Filipinas)",
  "4v0pnb": "Galés",
  "51lnU8": "Colognian",
  "5KynFd": "Checo",
  "5cyBop": "Inglés (India)",
  "5ff1Qr": "Tsonga",
  "5g+4ES": "Coreano (Corea del Norte)",
  "5riLBC": "Somalí (Yibuti)",
  "5vu2sQ": "Uzbeko",
  "5xPlEp": "Chino (Tradicional)",
  "62eqUV": "Luri del Norte",
  "6AZb8G": "Inuktitut (Currículo Educativo)",
  "6G/CAW": "Belga",
  "6am43/": "Kurdo Central",
  "6ebNfH": "Chino (Simplificado, RAE de Hong Kong)",
  "6gtes0": "Tamazight del Atlas Central",
  "6sur5u": "Danés (Groenlandia)",
  "7Gt5UH": "Sánscrito",
  "7k8oo8": "Alemán (Austria)",
  "7wLEyk": "Manés",
  "7yHu97": "Letón",
  "8MDM0L": "Tamil (Sri Lanka)",
  "8oEDHH": "Francés (Marruecos)",
  "93yDUJ": "Sami del Sur (Noruega)",
  "9cbhiA": "Árabe (Mundo)",
  "9ftsGr": "Inglés (Malasia)",
  "9ltErv": "Romanche",
  "9uEO2O": "Asturiano",
  AAf440: "Sesotho sa Leboa",
  ALhR5U: "Quechua (Perú)",
  "AQfg7+": "Francés (Congo - Kinshasa)",
  AahSYM: "Uzbeko (Árabe)",
  AeHTyT: "Inglés (RAE de Hong Kong)",
  "B+59h1": "Mongol (Mongol Tradicional)",
  B8qZTI: "Armenio",
  B9ZGRE: "Lao",
  BFf5tN: "Francés (Canadá)",
  BgGwdt: "Vietnamita",
  BpUgM5: "Neerlandés (Bonaire, San Eustaquio y Saba)",
  BtqqJK: "Español (Honduras)",
  CBhHg6: "Fula (Latín, Nigeria)",
  CDbpEz: "Islandés",
  CFRfr5: "Dzongkha",
  CauPny: "Catalán (Francia)",
  Ccf8zA: "Español (Uruguay)",
  DBHTS0: "Inglés (Australia)",
  DMjlMC: "Alemán (Bélgica)",
  DW0c2K: "Español (Chile)",
  DzWKvp: "Georgiano",
  "EP6mL+": "Manipuri",
  EREJay: "Sami (Lule)",
  EeOqFb: "Portugués (Santo Tomé y Príncipe)",
  EzFn0W: "Neerlandés (Aruba)",
  F38yZH: "Somalí",
  "FHLC+T": "Alemán (Liechtenstein)",
  Fxzz1N: "Sueco (Finlandia)",
  FzgpJw: "Bengalí",
  G7wzBO: "Árabe (Emiratos Árabes Unidos)",
  "GF/5qr": "Tachelhit",
  GGLJ5z: "Corso",
  GHtHh4: "Maorí",
  "GRMM/R": "Alsaciano (Francia)",
  "GZ+vSv": "Siríaco",
  GnC74O: "Tibetano",
  GqQl0h: "Italiano",
  GsOiFJ: "Inglés (Sudáfrica)",
  Gwyv4n: "Panyabí",
  "H/OHWA": "Filipino",
  H4fFDA: "Sami del Norte",
  H73FDV: "Uigur",
  "H7jT/h": "Albanés (Kosovo)",
  HDDkEc: "Zulú",
  HVCuT9: "Inglés (Alemania)",
  HZPa57: "Gaélico Escocés",
  "Hhe/Ef": "Español (Brasil)",
  Hj8GDj: "Guyaratí",
  Hq92CJ: "Hawaiano",
  HqCNsI: "Noruego",
  "I/+zqv": "Inglés (Guernsey)",
  I42yCw: "Inglés (Canadá)",
  IC7HXP: "Tigriña",
  IDCrtf: "Finlandés",
  IEUJ0j: "Alemán (Luxemburgo)",
  "IR/BFt": "Somalí (Etiopía)",
  ItGyiB: "Canarés",
  Iz1WLp: "Urdu",
  J1rnrw: "Esloveno",
  J5rPWm: "Español (Ecuador)",
  JPFRXM: "Inglés (Malta)",
  JVK3dg: "Alemán",
  JkretN: "Inglés (Finlandia)",
  Js4yYb: "Fula",
  "Jsem/p": "Mohawk",
  KDsjWJ: "Tamazight Marroquí Estándar",
  "Kj/zcq": "Francés (Mónaco)",
  LX0RZR: "Fula (Adlam)",
  Laghvq: "Kinyarwanda",
  Ll0N3I: "Cheroqui",
  MESBkg: "Xhosa",
  MJQbru: "Bashkir",
  Mbp9v6: "Árabe (Siria)",
  Mt9Ngn: "Hebreo",
  N4oAho: "Sesotho",
  NLZIcM: "Neerlandés (Bélgica)",
  NObQUE: "Afrikáans",
  "NV+8r2": "Mapuche",
  NVQG0j: "Dhivehi",
  Nevbjx: "Fula (Latín, Mauritania)",
  NfTD2i: "Español (Venezuela)",
  NhbCYP: "Valenciano (España)",
  NtuQMz: "Portugués (RAE de Macao)",
  "O/Bw0H": "Serbio (Latín, Kosovo)",
  OKUlj2: "Húngaro",
  OSMagZ: "Francés",
  Oju9iC: "Mongol",
  P23feN: "Español (Belice)",
  "P91ei/": "Tayiko",
  PE6jNM: "Español (Argentina)",
  PO8fNg: "Portugués (Timor Oriental)",
  POQTzM: "Francés (Senegal)",
  PSoXmh: "Odia",
  Pa7aMt: "Árabe (Líbano)",
  Pl3tfG: "Sueco",
  PsNb95: "Irlandés",
  Q8eBZk: "Neerlandés",
  QBwWZp: "Oromo (Kenia)",
  Qcitp4: "Javanés",
  Ql51WU: "Maratí",
  R1VwTR: "Vasco",
  R325ks: "Español (América Latina)",
  R34HBa: "Árabe (Omán)",
  RRmxSU: "Quechua",
  RTbzBi: "Sorbio Superior",
  RWrQ2K: "Árabe (Argelia)",
  "RqsM+G": "Español (Nicaragua)",
  SUF5bX: "Inglés (Austria)",
  Sg9DRE: "Francés (Suiza)",
  SlWjJ2: "Sami del Sur",
  T9IHrN: "Luxemburgués",
  TQ7V9A: "Árabe (Marruecos)",
  Tddnlb: "Telugu",
  Tq0aui: "Jemer",
  UAHDtf: "Malayalam",
  UGFi6Q: "Árabe (Jordania)",
  Uc1vOK: "Albanés",
  "V+BaHn": "Pastún",
  V223G2: "Fula (Latín, Burkina Faso)",
  V2uMRt: "Tamil",
  VJbQAt: "Español (Panamá)",
  VKt1qn: "Nepalí (India)",
  VuQRaN: "Italiano (Suiza)",
  W6zXNX: "Español (República Dominicana)",
  WK7YIm: "Árabe (Yemen)",
  WQtbS0: "Inglés",
  WU7Urn: "Turco",
  WUUTG8: "Turcomano",
  Wlr6BV: "Catalán (Italia)",
  XAmFMw: "Croata",
  XNXAkr: "Quechua (Ecuador)",
  XT8v2Z: "Catalán",
  XjbxJQ: "Afrikáans (Namibia)",
  Xkmde4: "Chino (Simplificado, RAE de Macao)",
  Xx527p: "Sami del Norte (Suecia)",
  Y7CQhy: "Alemán Suizo",
  Y8mZTh: "Inglés (Jamaica)",
  Y941O5: "Eslovaco",
  YNjb1t: "Feroés",
  Ygp3rn: "Bosnio",
  "Z/MVyq": "Eslavo Eclesiástico",
  ZCh9e6: "Sorbio Inferior",
  ZQtURc: "Rumano (Moldavia)",
  ZjrmiJ: "Shona",
  "Zki/XJ": "Kazajo",
  a9U6ge: "Córnico",
  aO94Wj: "Urdu (India)",
  "aTZE+x": "Cachemiro (Devanagari)",
  aiXFTk: "Fula (Latín, Ghana)",
  bDNNJp: "Malayo (Indonesia)",
  bLqBa4: "Inglés (Nueva Zelanda)",
  bRIPjy: "Inglés (Israel)",
  "bT+IsS": "Malayo (Singapur)",
  bVuD3F: "Árabe",
  bfp8tQ: "Groenlandés",
  c3rP5p: "Inglés (Eslovenia)",
  cJbw13: "Chino (Tradicional, Taiwán)",
  cQRIur: "Inglés (Singapur)",
  d5MtIX: "Indonesio",
  dEIOuD: "Polaco",
  dPzT2w: "Bretón",
  drEx3O: "Suajili",
  e9Fovw: "Papiamento",
  eGmwHh: "Inglés (Suiza)",
  eSg76K: "Inglés (Gibraltar)",
  eSmbEf: "Irlandés (Reino Unido)",
  eWnJnC: "Hindi",
  efy66J: "Checheno",
  "f+NB92": "Español (Perú)",
  "f/8iNS": "Fula (Latín, Camerún)",
  "f5+iem": "Español (México)",
  f6Viji: "Pastún (Pakistán)",
  fkHabQ: "K'iche'",
  fv9aDa: "Sami (Inari)",
  "gHco+M": "Ruso (Moldavia)",
  gOsLMk: "Malgache",
  gWx9ey: "Serbio (Latín, Montenegro)",
  gfmlPE: "Inglés (Irlanda)",
  glnMAY: "Tachelhit (Latín)",
  gvaI7A: "Somalí (Kenia)",
  "h6q+Tn": "Prusiano",
  h9YX8r: "Tamil (Singapur)",
  "hEPDg/": "Occitano",
  hNSwvJ: "Fula (Latín, Liberia)",
  hcX72z: "Tamil (Malasia)",
  hmzrxz: "Sami del Norte (Finlandia)",
  hr7Bt0: "Portugués (Guinea)",
  i4jvwu: "Chino",
  "i5/TH8": "Español (Guinea Ecuatorial)",
  "iI431+": "Inglés (Países Bajos)",
  iKxsEO: "Nepalí",
  iTiaM1: "Guaraní",
  iXn58z: "Azerí (Eslavo)",
  ifdXl3: "Coreano",
  jG6ZfL: "Alemán (Italia)",
  jGXHMX: "Serbio (Latín, Bosnia y Herzegovina)",
  "jHvE/3": "N'Ko",
  joVZ4M: "Árabe (Egipto)",
  "k+bU6l": "Neerlandés (Sint Maarten)",
  k6RCbu: "Portugués (Luxemburgo)",
  kW1ixl: "Suajili (Uganda)",
  l8f1rC: "Cachemiro",
  lGAoQJ: "Suajili (Tanzania)",
  "lig/ia": "Bodo",
  lwerC3: "Español (Estados Unidos)",
  "m+zQs1": "Igbo",
  m421XM: "Ucraniano",
  "mP+2ZR": "Inglés (Trinidad y Tobago)",
  mQ30Fl: "Inglés (Islas Malvinas)",
  mQPNAb: "Sindhi",
  mgFsmM: "Inglés (Dinamarca)",
  "mkyn/R": "Árabe (Baréin)",
  mq4oU3: "Inglés (Jersey)",
  mvxq4r: "Gallego",
  n86rIs: "Kirguís",
  naThLg: "Griego",
  ncJAOw: "Birmano",
  nfKkEe: "Fula (Latín, Níger)",
  nzfKPJ: "Francés (Camerún)",
  "oCgi+u": "Amárico",
  "oh7xe+": "Sami (Lule, Noruega)",
  oiHWuC: "Alemán (Suiza)",
  ono6Zw: "Español (Guatemala)",
  ouSGKF: "Sami (Skolt)",
  pJE11U: "Setswana (Botsuana)",
  pVxDdM: "Mazandaraní",
  pcWfuB: "Setswana",
  pdfcvu: "Francés (Costa de Marfil)",
  pjF6Nn: "Sotho (Lesoto)",
  pqIrOS: "Árabe (Túnez)",
  q2N4yn: "Serbio (Eslavo)",
  qQDW8M: "Francés (Malí)",
  qRbMrx: "Yoruba",
  qYdUNv: "Tamazight del Atlas Central (Tifinagh)",
  qu9gJ5: "Árabe (Libia)",
  qwSYAN: "Portugués (Mozambique)",
  r8ZWqf: "Noruego Nynorsk",
  rcixhA: "Neerlandés (Curazao)",
  rcmyN3: "Persa (Afganistán)",
  rk5DA1: "Inglés (Bélgica)",
  sBC8AY: "Sindhi (Devanagari)",
  sHbxv8: "Inglés (Belice)",
  sRuB7H: "Malayo",
  sl0qaQ: "Árabe (Kuwait)",
  sliV2n: "Español (Paraguay)",
  syMU2g: "Francés (Bélgica)",
  tQJpug: "Catalán (Cerdeña)",
  tQi27b: "Konkani",
  tRgqyZ: "Serbio (Eslavo, Kosovo)",
  tdrfAE: " Inglés (Caribe)",
  u0KReQ: "Italiano (Ciudad del Vaticano)",
  u61cWR: "Español (Colombia)",
  u78bW4: "Macedonio",
  uCI04p: "Estonio",
  uVRPPZ: "Tártaro",
  ubfX8q: "Inglés (Zimbabue)",
  uh1OQN: "Wolof",
  upv4s2: "Portugués (Cabo Verde)",
  vSG3D5: "Español (Costa Rica)",
  viRRMu: "Serbio (Eslavo, Montenegro)",
  vo99Cy: "Inglés (Burundi)",
  vuf8EY: "Inglés (Islas Vírgenes Británicas)",
  vxR1y4: "Hausa",
  wVqnrV: "Persa",
  wra0CG: "Suajili (Congo)",
  wtZRFn: "Friulano",
  x0KMJr: "Inglés (Isla de Man)",
  xXkK79: "Mongol (Mongol Tradicional)",
  xeXtGt: "Inglés (Suecia)",
  xgB0JY: "Asamés",
  xoMuR7: "Walser",
  "xzWaZ/": "Español (Puerto Rico)",
  "y//NHV": "Azerí",
  y7nOlh: "Búlgaro",
  ydTOo2: "Francés (Luxemburgo)",
  z0tSbC: "Osetio",
  z1VBi8: "Rumano",
  zBWf5p: "Interlingua",
  zWU1xI: "Español (Bolivia)",
  "05KCjo": "Icono de aplicación:",
  "11uVJ/": "Recibir objeto",
  "1Qoc6t": "Nombre del proceso:",
  "2JW1Pt":
    "Por favor elija si desea enviar correos electrónicos al mismo tiempo",
  "70JpVD": "Nombre del proceso",
  "9AsSO/":
    "Por favor, elija si desea enviar mensajes de texto al mismo tiempo",
  "AH+jWQ": "Aplicación de Windows",
  Axagls: "Por favor seleccione una hora de finalización",
  FNIJXx: "Por favor seleccione reproducción con desplazamiento",
  Fir0oq: "Por favor seleccione el tipo de notificación",
  G4qgGm: "Todos los usuarios",
  G5gg2V: "El título del anuncio es obligatorio",
  IWPf2S: "Detalles del anuncio",
  IbWDVg: "Número de versión requerido",
  Km733q: "Por favor seleccione una hora de inicio",
  L24ioQ: "Título",
  L80hmc: "El título del anuncio no debe exceder los 30 caracteres",
  NDjXUx: "Ingrese el comando para implementar el archivo:",
  "Oex59+": "Lista de retorno",
  QHc9Qg: "Contenido del anuncio",
  QNomO6: "Por favor ingrese el número de versión",
  Qpcx6F: "El contenido del anuncio es obligatorio",
  RQyKsa: "Anuncio de Plataforma",
  TiK9WZ: "El nombre del proceso es obligatorio",
  TvOGLc: "Comando de archivo de implementación",
  UHuNzJ: "Por favor ingrese el comando",
  WtPk7v: "Enviar SMS simultáneamente",
  XbIN5K: "Por favor ingrese el nombre del programa",
  XeIKK7: "Centro de notificaciones",
  ZqioaF: "Título de la Notificación",
  aGxRt2: "contenido",
  cr1ymH: "Por favor seleccione la hora de envío",
  dY3og7: "Ícono de carga de aplicación:",
  eFDqHN: "Cargó la aplicación de Windows exitosamente",
  eSfTZf: "Cargar aplicación de Windows",
  "ghKe/+": "nombre del proceso",
  "h5yj+x": "Por favor ingrese el nombre del proceso",
  jAJbuk: "Anuncio de notificación",
  l36W55: "Reproducción con desplazamiento",
  lqQKL4: "Agregar por nombre de proceso",
  mKKd1R: "Por favor seleccione destinatarios",
  q9PHLT: "Aún no hay ningún anuncio",
  wYygRu: "Remitente",
  xXdMar: "Usuario especificado",
  xx40g7: "Título del anuncio",
  yKFvYY: "Enviar correos electrónicos simultáneamente",
  yfhtRM: "Adjunto",
  z5L9EV: "Actualizar aplicaciones de Windows",
  "bhv+8O": "Descargando",
  xzmRTb: "Solo muestra el historial de los últimos 7 días",
  "yrR/HC": "Instalando",
  ibYzs0: "Nombre del programa: {nombre}",
  ivzCMK: "La aplicación no se puede analizar.",
  mJBhe1: "La sincronización de archivos permite agregar hasta 10 archivos",
  "6oXjFu": "El formato de carga es incorrecto",
  KetfTt: "Tamaño máximo de imagen: 500 KB",
  baNBmh: "El tamaño de la imagen no puede exceder los 500 KB",
  tAjFr2: "Formatos de imagen: PNG, JPG, JPEG, BMP, GIF, SVG, WEBP",
  "3K02K/": "Configuración wifi incompleta",
  "5Cm9U3": "Notificación de mensaje",
  "Y6Q+iJ": "Por favor complete la configuración wifi",
  tugHWJ: "Volver a la lista de anuncios",
  "x/FhNQ": "Ver notificaciones",
  "+GRUnH": "Asia/Jovd",
  "+IL2pH": "Asia/Riad",
  "+J2Dyk": "América/Asunción",
  "+Ny8AK": "América/Puerto_Rico",
  "+RWig5": "Español (Bolivia)",
  "/2Wzyw": "América/El_Salvador",
  "/rG/9z": "América/Curazao",
  "0AuprP": "Pacífico/Tongatapu",
  "0X3KFO": "Temperatura de CPU",
  "0vIw5o": "América/Bogotá",
  "1YfhFP": "Asia/Dili",
  "2+A7qs": "Antártida/Mawson",
  "2+ec6P": "América/Danmarkshavn",
  "2FPNxz": "Asia/Dubái",
  "32RJkL": "América/Argentina/San_Luis",
  "33VS8L": "América/Maceió",
  "36csPo": "Europa/Zúrich",
  "3KlQfs": "Australia/Brisbane",
  "3LAnU7": "Atlántico/Feroe",
  "3MaR6w": "Europa/Tallin",
  "3NE037": "Asia/Ashgabat",
  "3svavz": "América/Miquelón",
  "42xSxy": "Asia/Novosibirsk",
  "4LAo5S": "América/Metlakatla",
  "4Sw/d9": "Asia/Krasnoyarsk",
  "4T/bEM": "América/Indiana/Vevay",
  "4WaJo8": "América/Scoresbysund",
  "4Wgk5f": "Europa/Andorra",
  "4ZRHuu": "Atlántico/Georgia_del_Sur",
  "4cXOI/": "Asia/Ereván",
  "4jryq3": "América/Dakota_del_Norte/New_Salem",
  "4sqSH4": "Asia/Khandyga",
  "564gFy": "África/Accra",
  "6SQvm5": "Asia/Pontianak",
  "6X6msx": "Uso de almacenamiento",
  "6xnHrJ": "Europa/Berlín",
  "72KWoU": "Australia/Sídney",
  "778/Xc": "América/Tegucigalpa",
  "7JA1Vf": "América/Argentina/Mendoza",
  "7L+CJm": "Europa/Helsinki",
  "7geAkY": "América/Argentina/Buenos_Aires",
  "7teo40": "Pacífico/Chuuk",
  "87d7yX": "Pacífico/Guadalcanal",
  "8Gi8qJ": "Australia/Broken_Hill",
  "8eL/hC": "Asia/Jerusalén",
  "8hJsOE": "Asia/Bangkok",
  "8qYKWy": "Pacífico/Chatham",
  "8woxjy": "Asia/Kuala_Lumpur",
  "A3y/jB": "América/Argentina/Río_Gallegos",
  ACHtOA: "Asia/Kamchatka",
  AFZYEo: "Asia/Brunéi",
  ALGNzc: "Asia/Magadan",
  AWhHY3: "América/Río_Branco",
  ApnLV0: "Asia/Almatý",
  AqKGKn: "Asia/Yakarta",
  As1lP0: "Índico/Kerguelen",
  "Aytpe/": "Europa/Mónaco",
  B6rikn: "América/Indiana/Indianápolis",
  B9NkmN: "Europa/Luxemburgo",
  BXdJNy: "Atlántico/Stanley",
  BgYCgo: "Antártida/Casey",
  C21hEn: "Europa/Belgrado",
  C7HjWu: "Europa/Ámsterdam",
  CBkGYl: "África/Maputo",
  CC9Jw3: "Asia/Makassar",
  CIImWq: "Pacífico/Majuro",
  "CNMmH/": "Asia/Yakutsk",
  CR8w2m: "América/Gran_Turca",
  CUsFOe: "América/Cayena",
  D2gXtv: "América/Menominee",
  D4VBw5: "Antártida/DumontDUrville",
  DincSy: "Australia/Lord_Howe",
  DoPuye: "Asia/Damasco",
  "E/3oPZ": "Asia/Macao",
  E2NUw6: "África/Johannesburgo",
  EJA24j: "Pacífico/Norfolk",
  EgGVTj: "Pacífico/Enderbury",
  EhPWhM: "América/Cuiabá",
  EmxcJt: "América/Yakutat",
  Ewhh7n: "Europa/Sofía",
  FXD37C: "América/Panamá",
  FsXquv: "Asia/Pyongyang",
  GIHcco: "América/Godthab",
  GIwuGT: "Europa/Bruselas",
  GNkv6K: "África/El_Aaiún",
  "H8+X66": "Asia/Khandyga",
  HDVqMh: "América/Argentina/San_Juan",
  HEpXP8: "América/Denver",
  HOEyDX: "América/La_Paz",
  HS4Jyv: "Europa/Uzhgorod",
  Hh1tUP: "América/Guayaquil",
  HkGIFU: "Antártida/Davis",
  HoSy6c: "Pacífico/Kwajalein",
  HuSwkp: "Asia/Ust-Nera",
  HzSbcD: "Antártida/Troll",
  I3bX6d: "Asia/Urumqi",
  IBZBgD: "Europa/Estambul",
  IHXrCK: "América/Los_Ángeles",
  IKeroX: "Asia/Jayapura",
  ILjenb: "América/Indiana/Marengo",
  IgbKn9: "Asia/Ho_Chi_Minh",
  InLlSF: "América/Paramaribo",
  J5iABC: "Asia/Karachi",
  JHjx5l: "América/Anchorage",
  "JURm/W": "Antártida/Palmer",
  "Jc5/LG": "Asia/Omsk",
  JrjIBq: "América/Puerto_Príncipe",
  K9TF6H: "Asia/Hong_Kong",
  KAKu2d: "Pacífico/Numea",
  KEr7iI: "Pacífico/Palau",
  "KaS+yS": "América/Costa_Rica",
  KyBesr: "Pacífico/Rarotonga",
  M3Bd2i: "Pacífico/Pitcairn",
  MAVhWe: "Europa/Oslo",
  MAWdwn: "Asia/Colombo",
  McxhaP: "América/Belice",
  MeSuny: "América/Barbados",
  MmTr9O: "África/El_Cairo",
  Mr4JiU: "Índico/Chagos",
  MxWLCa: "Pacífico/Marquesas",
  NW4CG5: "África/Trípoli",
  NWpmvK: "Europa/Moscú",
  Nd0dlz: "América/Argentina/Catamarca",
  NhHERf: "África/Jartum",
  O2VzkZ: "Europa/Gibraltar",
  OEWR5m: "América/Recife",
  OPvCOV: "Atlántico/Reikiavik",
  OdITFl: "Índico/Cocos",
  Oj7H2e: "Europa/Malta",
  OnT6Rq: "América/Argentina/Salta",
  P5ijks: "Asia/Chita",
  P8Gz8g: "Asia/Samarcanda",
  P8fuMA: "Pacífico/Apia",
  PE4Jv1: "Europa/Kaliningrado",
  "PHe5b/": "América/São_Paulo",
  PQTASm: "África/Nairobi",
  PSTE5v: "Asia/Teherán",
  "Pr/HJJ": "América/Thule",
  Q93ucv: "Europa/Dublín",
  Q9eZjv: "América/Lima",
  QIrZ4x: "Pacífico/Kosrae",
  QXW2mv: "América/Argentina/Tucumán",
  QlNyHt: "Asia/Seúl",
  RWGdDh: "Europa/Bucarest",
  RWhf30: "Pacífico/Auckland",
  RbCEhx: "América/Kentucky/Louisville",
  RdB8rs: "América/Kentucky/Monticello",
  Ri5GFC: "Europa/Volgogrado",
  Rzjtg0: "Antártida/Macquarie",
  "SB+r6t": "Índico/Navidad",
  "SDmnE+": "Asia/Amán",
  SO2rVX: "África/Windhoek",
  TSIb1O: "Asia/Beirut",
  TVzP2K: "Pacífico/Isla_de_Pascua",
  TmXGJf: "Pacífico/Pago_Pago",
  Tp6vAo: "Atlántico/Azores",
  "Tvk1/+": "Asia/Bakú",
  TxnfAW: "Europa/Simferópol",
  UU6RxP: "Pacífico/Fakaofo",
  "W+BF0N": "Europa/Kiev",
  WF6jLL: "Asia/Irkutsk",
  WGbNbT: "Europa/Roma",
  WH83gM: "Australia/Eucla",
  WM9F6N: "Europa/Budapest",
  WT4u2Q: "África/Bissau",
  Wd588a: "América/Juneau",
  "X+krOQ": "Europa/Londres",
  XG3VTC: "Índico/Maldivas",
  XGLQKt: "Índico/Mauricio",
  XJz9XQ: "América/Chicago",
  XcLHzQ: "América/Santo_Domingo",
  XgCqrC: "Asia/Kuching",
  "Xs2qb/": "Asia/Shanghái",
  YUT4gj: "Europa/Lisboa",
  YZ2GGD: "Asia/Singapur",
  "Ywxpi/": "Índico/Mahe",
  Z0uRcM: "Asia/Daca",
  ZKdJhk: "América/Boa_Vista",
  ZZib2d: "Australia/Hobart",
  Zjiy1h: "Pacífico/Nauru",
  ZnA7Nz: "Asia/Hebrón",
  a25tfu: "Asia/Calcuta",
  a4hALt: "Europa/Samara",
  aIkFIc: "Europa/Riga",
  aJXo8B: "Asia/Sajalín",
  an8KV9: "Europa/Estocolmo",
  "bPKD9+": "América/Bahía",
  bpugpH: "Pacífico/Galápagos",
  bwibOg: "América/Indiana/Tell_City",
  bwxucD: "Antártida/Rothera",
  byIMHD: "América/Indiana/Winamac",
  cGo7xU: "Europa/Viena",
  cL4iBR: "Pacífico/Wake",
  cR6lQr: "América/Nueva_York",
  cY9R69: "Asia/Yangon",
  "cdP+DQ": "Carga de memoria",
  cfqioE: "América/Martinica",
  ckkIgb: "América/Santarém",
  "d+p45H": "Antártida/Estación",
  "dD/ri/": "Pacífico/Efate",
  dVOPAi: "Monitoreo de dispositivo fuera de línea",
  dmQidl: "Pacífico/Wallis",
  dnhrx5: "Europa/Atenas",
  dsc2e1: "América/Campo_Grande",
  dwtkZ7: "Atlántico/Cabo_Verde",
  e7x56t: "América/Eirunepé",
  eCaCt4: "Europa/Copenhague",
  eJ850A: "América/Caracas",
  eUPrSB: "América/Argentina/Córdoba",
  "eiH+8b": "África/Yamena",
  esrASO: "América/Manaos",
  "f/kdJq": "Asia/Dusambé",
  f2wvqe: "Asia/Qyzylorda",
  fRTjpp: "América/Puerto_España",
  felOXC: "Europa/Minsk",
  "fr++q+": "América/Dakota_del_Norte/Centro",
  fwXmSX: "Índico/Reunión",
  g8yytK: "Leído",
  g9Ro8s: "Asia/Thimphu",
  gCnWv3: "América/Guatemala",
  "gWP+OK": "América/Porto_Velho",
  gY9Idz: "Contenido de notificación",
  hMJvQy: "Asia/Aqtobe",
  hMvFT8: "Pacífico/Fiyi",
  i9kfO3: "Australia/Perth",
  ia2KGW: "Australia/Lindeman",
  iemojj: "América/Indiana/Petersburg",
  iktlFx: "África/Lagos",
  ioR1tU: "Australia/Melbourne",
  irTGxZ: "América/Nassau",
  iuG5L2: "Pacífico/Funafuti",
  jArote: "Asia/Choibalsan",
  jGg3Qb: "Atlántico/Bermudas",
  "kPnKK/": "Pacífico/Tarawa",
  kQfkBY: "Pacífico/Niue",
  kX80z5: "África/Casablanca",
  kb4vnt: "Asia/Tiflis",
  kibwvT: "América/Araguaina",
  klPlFN: "Atlántico/Madeira",
  ktaxSw: "No leído",
  kzL66g: "América/Sitka",
  l0DTVX: "Europa/Chisináu",
  l3HZXk: "América/Argentina/Jujuy",
  lUObgG: "Asia/Novokuznetsk",
  "lY+G1f": "Europa/Zaporiyia",
  ldw5JF: "América/La_Habana",
  ldz3Qp: "América/Nome",
  "luv+ak": "Antártida/Showa",
  m372k4: "Asia/Aqtau",
  mC90qt: "América/Fernando_de_Noronha",
  maWrSV: "Asia/Qatar",
  mpmcYh: "América/Jamaica",
  mzw9vO: "Asia/Vladivostok",
  nFRGgT: "Asia/Nicosia",
  nG6bDa: "Pacífico/Ponapé",
  nNIaxy: "Australia/Currie",
  "nTx/do": "África/Monrovia",
  ndfOI1: "Asia/Tashkent",
  nfV4cd: "Pacífico/Port_Moresby",
  nt7Sni: "América/Fénix",
  "oNgMl/": "Europa/Varsovia",
  ox9xcC: "Asia/Ulan_Bator",
  "p/Y+A9": "Asia/Oral",
  p60kqM: "América/Indiana/Knox",
  "pDAAq+": "Pacífico/Navidad",
  "pH7u/B": "Europa/Praga",
  pctdGN: "Pacífico/Tahití",
  pkQvvT: "Asia/Gaza",
  qZesUE: "Pacífico/Bougainville",
  qm1rPH: "América/Adak",
  qrxb3P: "América/Managua",
  qyspJO: "Asia/Bagdad",
  rB8hza: "América/Boise",
  rDnYpj: "América/Detroit",
  "rSU+yK": "Europa/Tirana",
  rhrAj5: "Asia/Manila",
  sCbQzB: "Pacífico/Guam",
  ssEhAp: "Australia/Darwin",
  tGy5jw: "Asia/Bishkek",
  tb5CXr: "Europa/París",
  u8OEeb: "Asia/Anadyr",
  umaIEg: "América/Argentina/Ushuaia",
  "uq/hF0": "Asia/Tokio",
  v1R8a6: "América/Guyana",
  v9QImt: "Asia/Kabul",
  vvPXpH: "Asia/Katmandú",
  w6MqYv: "América/Belén",
  "wHl/4A": "Australia/Adelaida",
  wQ6hxa: "África/Túnez",
  wTov5v: "América/Fortaleza",
  wu6z2j: "Pacífico/Gambier",
  xC5dF9: "África/Argel",
  xV1AHg: "Asia/Ekaterimburgo",
  xV72W5: "América/Santiago",
  "xefyX+": "América/Dakota_del_Norte/Beulah",
  yBB7Af: "América/Argentina/La_Rioja",
  yjTwMp: "Asia/Taipéi",
  yk6eIX: "Pacífico/Honolulu",
  z4BN1R: "América/Caimán",
  zMTRSM: "Carga de CPU",
  zOIpOr: "América/Indiana/Vincennes",
  zooIwl: "Europa/Vilna",
  "/+bsEl": "América/Monterrey",
  "/Gtqfz": "América/Mérida",
  "22S38U": "América/Atikokan",
  "3TyuhP": "América/Ojinaga",
  "3nz5UA": "África/Abiyán",
  "5LGVs8": "América/Inuvik",
  "5hwp3A": "América/Winnipeg",
  "75rZvt": "América/Fort_Nelson",
  B1cpxi: "América/Bahía_Banderas",
  DB1i32: "América/Chihuahua",
  EjYbG7: "Atlántico/Canarias",
  JJlhYG: "América/Moncton",
  JK7opY: "América/Rainy_River",
  JMiQE7: "América/Swift_Current",
  JNgj9q: "América/Vancouver",
  LQs9br: "América/Creston",
  TV0vfT: "América/Hermosillo",
  TtsBNI: "América/Santa_Isabel",
  "V/ychw": "América/St_Johns",
  V3RDY8: "América/Cambridge_Bay",
  WrrSc3: "Europa/Madrid",
  XAJf4I: "América/Amarillo cuchillo",
  Xf2rFn: "América/Mazatlán",
  "YIziP+": "América/Rankin_Inlet",
  Zw6GOE: "América/Regina",
  cvhrwM: "América/Pangnirtung",
  d4TeTf: "América/Whitehorse",
  dS4Q9B: "América/Edmonton",
  dXgU6w: "América/Matamoros",
  damxMJ: "América/Nipigon",
  hrTtyK: "América/Dawson_Creek",
  i7y8PO: "África/Ceuta",
  mYnwj6: "América/Iqaluit",
  mZSYZK: "América/Cancún",
  n4UQqL: "América/Dawson",
  pIep8S: "América/Ciudad_de_México",
  pZHBxH: "América/Resolute",
  puzgCP: "América/Toronto",
  sf6FE5: "América/Glace_Bay",
  trLh1J: "América/Tijuana",
  vmXV5r: "América/Blanc-Sablon",
  x062Q4: "América/Halifax",
  x5t5ol: "América/Thunder_Bay",
  x8MKpa: "América/Goose_Bay",
  qhku2P: "(Windows 7 aún no es compatible)",
  LjaYAu:
    "(El dispositivo se reiniciará automáticamente después de aplicar la configuración.)",
  SsOQaU: "Se debe configurar la ruta del dispositivo Android",
  ftJgyV: "Se debe verificar un dispositivo",
  tp71Dv: "Se debe configurar la ruta del dispositivo de Windows",
  "+x/2kt": "Reglas del dispositivo",
  "781mpm": "3. Reglas de nomenclatura predeterminadas de la empresa",
  EJYMZz:
    "Después de cerrar, puede descargar la nueva versión de Ora e instalarla usted mismo, o actualizarla manualmente mediante el comando del dispositivo-Actualización de Ora.",
  QWNGGT: "Cantidad de dispositivos",
  QkSHo2:
    "Después de desactivar las actualizaciones automáticas, las diferencias en las versiones de Ora en el dispositivo pueden causar que algunas funciones dejen de estar disponibles",
  RFear4: "2. Período de tiempo de actualización del dispositivo (hora local)",
  VUYwkz: "Por favor seleccione una aplicación",
  Z8Wkvb:
    "Después de encenderlo, Ora se descargará y actualizará automáticamente si hay una nueva versión.",
  bc4BgP: "Otra última vez en línea",
  c5daOt: "Número de tiendas ({num})",
  qDHqff: "Reinicio automático",
  zbqD5q: "valor",
  FtTdh0: "1. {ora} se actualiza automáticamente",
  Em0SLE: "Reiniciar",
  Gvm3Ry:
    "¿Está seguro de que desea reiniciar {appName} de ({name})? La supervisión de la aplicación continuará después de reiniciar.",
  Ixi8kg: "Recordatorio de reinicio",
  bbMhTk: "¿Estás seguro de que quieres reiniciar?",
  "99tjyG": "IP",
  "9a/nvJ": "Resultado de la operación",
  BdDDD0: "Registro del dispositivo",
  MbqxKj: "Nombre de la plantilla",
  OjLqmy: "Desconocido",
  V6d4dz: "Detalles de la operación",
  "hD/l+2": "Tipo de operación",
  "s+OQvW": "Operador",
  yc8eep: "Seleccionar resultados",
  "/5RjKG": "Token falla",
  "0nwYmb": "Todos los tipos de notificación",
  "ZC7J/S": "ipo de notificación",
  pm5kAg: "Por favor, vea el contenido en los detalles",
  "y8e4w8": "Sólo tiene efecto después de reiniciar el dispositivo",
  "vjxfR4": "(instalador exe, archivo msi)",
  "8DORrA": "Puerto USB",
  "AFx0WP": "Tipo de búsqueda",
  "GyqBiS": "Imprimir información",
  "L3HWwz": "Descripción del dispositivo",
  "OuXnTb": "¿Está seguro de que desea restablecer este puerto USB?",
  "QZM++f": "¿Está seguro de que desea reiniciar la impresora?",
  "RCjVsb": "Identificación del dispositivo",
  "RJpihQ": "¿Está seguro de que desea deshabilitar este puerto USB?",
  "adMZWx": "Agregar periféricos",
  "j3iWkN": "No se puede repetir la impresora",
  "kL3ndq": "¿Desea eliminar esta impresora?",
  "r8lAlx": "Gestión de periféricos",
  "wIFJtf": "No conectado",
  "zKsJJS": "¿Está seguro de que desea habilitar este puerto USB?",
  "zY36V+": "Conectado",
  "2Rco7+": "Hora de subida:",
  "5JrKIs": "La implementación de la función se ha programado para el momento de lanzamiento seleccionado.",
  "E62yo0": "Error en la implementación de la función, reintentando.",
  "HI9nIp": "Eliminar archivos",
  "IX5jed": "Estado de implementación del archivo de configuración",
  "Mxw3XE": "El archivo bat no se llama instalar ni desinstalar",
  "N3h+Aq": "Error en la implementación de la función",
  "N9kr00": "Desinstalar la aplicación después de la transferencia",
  "OY+bYK": "Confirmar, no volver a mostrarlo",
  "PZD5BD": "Este proyecto ha sido utilizado por el archivo de configuración [{name}] y no se puede eliminar. Si desea eliminarlo, elimínelo del archivo de configuración",
  "Pzsa4g": "La implementación de la función está lista",
  "RzXkm3": "Lista negra habilitada",
  "SzN0Xf": "Eliminar propietario del dispositivo",
  "VvutjQ": "Función",
  "XPoLPc": "Se recibió la implementación de la función y se procesará pronto.",
  "Xsx53E": "¿Está seguro de que desea eliminar este archivo?",
  "c7ABGP": "La implementación de la función está esperando la respuesta de Ora",
  "d6mNdO": "Lista blanca habilitada",
  "f9tP6e": "¿Está seguro de que desea eliminar esta aplicación de Windows?",
  "hmCei2": "Desinstalar la aplicación después de eliminarla",
  "ii1TCF": "(Por favor, nombre el archivo bat en el paquete comprimido como instalar o desinstalar)",
  "mmGD7U": "La implementación de la función está en curso.",
  "uL4MGN": "¿Estás seguro de que deseas eliminar esta aplicación de Android?",
  "wzPSgE": "Lista negra/Lista blanca",
  "xAk1ic": "La función se ha implementado correctamente",
  "yWzW01": "(instalador exe, archivo msi, paquete comprimido zip)",
  "yvnu2T": "Nombre de la plantilla de configuración",
  "CqT/5i": "Este archivo ha sido compartido. ¿Seguro que deseas eliminarlo?",
  "wboZY3": "Hora del informe",
  "6kNt8v": "La próxima hora",
  "Rkh3mc": "Última hora",
  "+/nbWD": "Próxima hora de cambio {time}",
  "1ULJr+": "Modo de aplicación única",
  "CxuMXm": "Debe agregar una aplicación",
  "Gp3iu0": "Subir fondo de pantalla local",
  "M0GExq": "Si el dispositivo ya tiene la aplicación, desinstale la versión original y vuelva a instalarla",
  "OYWCEU": "Aplicación de carga local",
  "PyHYs3": "Cerrar conexión VNC",
  "QZCAIP": "ID de la aplicación",
  "X+8ega": "Selección del modo quiosco",
  "bLP2/B": "Comprobar el estado de la aplicación de configuración",
  "bneXBI": "Mensaje de cambio",
  "czLSET": "Agregar una aplicación manualmente",
  "eg9Cwk": "Desde la empresa de ubicación actual",
  "f8ijF3": "Se ha emitido el comando",
  "i8wqAy": "Subir aplicación local",
  "oiRBSj": "Tras la confirmación, el dispositivo Se aplicará la nueva configuración. ¿Seguro que desea aplicarla?",
  "qG2/EZ": "Subida de archivos local",
  "qH+vs7": "Lista blanca",
  "qTgFpp": "De la empresa a la que pertenece la cuenta",
  "qwHBkg": "No se registran los cambios de configuración; todos los dispositivos usan la configuración predeterminada",
  "sB85Wu": "Subida local",
  "uqEE8V": "Esta configuración solo es aplicable a Android Ora 2.14.25",
  "vtUGfp": "Reglas de nomenclatura predeterminadas de la empresa",
  "QgHuyM": "Dokokin yin suna",
  "+Bas2b": "Duración: {duration}",
  "+a6DnG": "En revisión",
  "/CFd+q": "Abierto",
  "0JQoTX": "Revisión fallida",
  "0Ru5zG": "Tamaño: {size}",
  "0UhE3z": "Estado de reproducción",
  "0btyN9": "Duración:",
  "1/U2kj": "Vídeo",
  "1qoi3T": "Imagen",
  "3HqLlX": "Contenido nuevo",
  "4jU7ke": "Iniciar reproductor de contenido",
  "4nG/GN": "Nombre del contenido",
  "5RR9aM": "Pausa del lote",
  "5XSNyG": "Materiales subidos correctamente",
  "6K/a0B": "Pausa",
  "6wAcmz": "Seleccione el tiempo",
  "7M1nFY": "¿Está confirmando la eliminación de la plantilla? {name}?",
  "7OW60G": "Borrar selección de hora",
  "7Ouq4k": "Orden: {sort}",
  "7cAtfM": "Horas",
  "7wofGo": "Aplicación",
  "9c8SPP": "Tamaño",
  "BhWZJo": "Nombre del recurso",
  "C55Kjj": "Contenido de reproducción",
  "D+32Ow": "Centro de gestión de recursos",
  "EBMdAL": "Creado correctamente",
  "ECm6hH": "¿Está seguro de que desea eliminar este recurso ({name})?",
  "ELFG/t": "Buscar dispositivo",
  "IP9Kbk": "Las imágenes no pueden superar los 15 MB",
  "Ie9WHB": "Subir material",
  "KOVFgK": "En espera de revisión",
  "Lqca+c": "Cambio de reproductor",
  "MDACCo": "Reproducción correcta",
  "MWJG8I": "Nombre: {name}",
  "Ut8+i2": "Aprobado",
  "Xi/+KE": "Añadir franja horaria",
  "YuZxve": "Seleccionar contenido",
  "bKLb1C": "Reproducir",
  "bYujGa": "Crear plantilla",
  "fFaC3Z": "Tiempo de reproducción",
  "gVXoXc": "Administración de contenido",
  "i9lOCU": "La fecha de inicio seleccionada es anterior a hoy",
  "iHQiQV": "Reproducción por lotes",
  "iJIOBp": "Error de análisis",
  "iRR+fJ": "Información de depuración",
  "l9XE8F": "Aprobado",
  "lchpP8": "Aplicación correcta",
  "m8CFrl": "Crear nueva plantilla",
  "nbp4U6": "Lista de plantillas de contenido",
  "oUgWVb": "Tipo: {type}",
  "p/EHrl": "El tamaño máximo del vídeo no puede superar 10 GB",
  "qx5UwR": "Seleccione un dispositivo",
  "rBWtYz": "Hora del último cambio",
  "rnpMD3": "Desactivado",
  "sux9FA": "Límite inferior de entrada: 1",
  "tRm3bw": "Pausa exitosa",
  "uhTa0i": "Vista previa",
  "w1cMGO": "Fecha de finalización",
  "ztKQno": "Duración",
  "J3dxzb": "Nubis actualmente admite los formatos de imagen JPEG y PNG. Los vídeos deben estar codificados con el códec H.264. Los formatos de archivo compatibles incluyen MPEG-4 y MOV. Un códec es un software o hardware que comprime los datos para una transmisión más rápida y los descomprime a su formato original. El códec H.264 se utiliza habitualmente para grabar, comprimir y distribuir contenido de vídeo. Un formato de archivo de vídeo puede contener uno o más códecs. Si su archivo de vídeo MOV o MPEG-4 no supera la revisión, compruebe que el códec utilizado para codificar el vídeo sea H.264.",
  "M5Vtr/": "Editar plantilla",
  "b1xi4S": "Vista previa de plantilla",
  "kNhfaL": "¿Está seguro de que desea eliminar la plantilla ({name})?",
  "kqgd4D": "Añadir al menos un tiempo de ejecución.",
  "36pf2y": "Historial de contenido",
  "3izvEF": "Seleccionar archivo",
  "9mG+jv": "El tamaño del archivo excede el espacio disponible",
  "AlFkwq": "Número de dispositivos instalados",
  "C8ZuKU": "Ancho de la imagen",
  "E0Czos": "Alto de la imagen",
  "I73XLQ": "Eje Y de la imagen",
  "JbroVc": "Nubis Cast",
  "MMqJtu": "Seleccione una imagen o un vídeo",
  "Pv/1oy": "Visualización de contenido",
  "Rrwy85": "Creador",
  "T8Y38H": "Archivo de imagen (*.jpg/*.png)",
  "VJ7wHx": "Número de dispositivos a instalar",
  "WI3Hl5": "Eje Y del vídeo",
  "Y2Wh/g": "Archivo de vídeo (*.mp4/*.mov)",
  "YLvNj+": "Para implementar",
  "kUbrNT": "Cargue primero el archivo al Centro de Gestión de Recursos. Solo los archivos aprobados pueden usarse como plantillas.",
  "n997QX": "Altura del vídeo",
  "rBD8kj": "Eje horizontal de la imagen",
  "uCmncQ": "Ancho del vídeo",
  "QwmhEP": "Historial de contenido",
  "8vC+0s": "Debe seleccionar un contenido de reproducción",
  "jG/AFY": "Tras la confirmación, el dispositivo aplicará la nueva configuración y no podrá modificarse en un día. ¿Está seguro de que desea aplicarla?",
  "AxZAkZ": "El contenido digital subido a esta plataforma será revisado automáticamente por el departamento de moderación de contenido de Amazon Rekognition para reducir el riesgo de publicación. Si la revisión automática falla, puede optar por revisarlo manualmente; sin embargo, en este caso, esta plataforma no se responsabilizará de ningún impacto posterior.",
  "Oyd/7c": "Aprobación manual",
  "wyHcKZ": "Recordatorio de aprobación",
  "32HMy/": "Versión de {nubis} Cast",
  "IS73A4": "La hora de inicio no puede ser posterior a la hora de finalización",
  "jCAPQ2": "Modo de {nubis} Cast",
  "sWmzFs": "Hora de última actualización de {ora}",
  "sctjLN": "Hora de última conexión de {ora}",
  "uoBkfP": "Estado de última actualización de {ora}",
  "3yichR": "Fecha de última modificación",
  "d+otpZ": "Versión de lanzamiento",
  "k30s+D": "Fecha de última publicación",
  "9bgunT": "Cuando está desactivado, puede descargar e instalar manualmente la última versión de {ora} o actualizarla manualmente mediante el comando del dispositivo: {ora} update.",
  "Yh8vRi": "Cuando está activado, se descargará y actualizará automáticamente cuando haya una nueva versión de {ora} disponible.",
  "ZO2gEn": "Versión de {nubis}",
  "r+yR7v": "{nubis} Cast",
  "uf58G7": "Cuando las actualizaciones automáticas están desactivadas, las diferencias en la versión de {ora} del dispositivo pueden provocar que algunas funciones no estén disponibles.",
  "y98D3X": "Eje vertical del vídeo"
};
